   // 获取当前HTML元素的类列表
   var htmlClasses = document.documentElement.classList;

   // 检查类列表中是否包含'dark-theme'
   var isDarkTheme = htmlClasses.contains('dark-theme');

   // 根据条件设置$theme_path的值
   var $theme_path = isDarkTheme ? '/dark-theme' : '';

// const { sync } = require("del");
var personal = null;
let page_num = {
    characters: 1,
    characters_total: 0,
    characters_num: 0,
    storys: 1,
    storys_total: 0,
    storys_num: 0,
    favorites: 1,
    favorites_total: 0,
    favorites_num: 0,
    likes: 1,
    likes_total: 0,
    likes_num: 0,
    public: 1,
    public_total: 0,
    public_num: 0,
    storys_public: 1,
    storys_public_total: 0,
    storys_public_num: 0,
    private: 1,
    private_total: 0,
    private_num: 0,
    storys_private: 1,
    storys_private_total: 0,
    storys_private_num: 0,
};
filtrate = 3, nsfw = 1;
var my_card_index = 0, my_story_card_index = 0, robot_type = null;
if (cookie.getcookie('profile_filtrate')) {
    var profile_filtrate = JSON.parse(cookie.getcookie('profile_filtrate'));
    console.log(profile_filtrate);
    if (profile_filtrate.filtrate == 3 && profile_filtrate.openid == JSON.parse(cookie.getcookie('userInfoData')).openid) {
        filtrate = 3;
        $('.classification .genderAll i').eq(0).html('Latest');
    } else if (profile_filtrate.filtrate == 1 && profile_filtrate.openid == JSON.parse(cookie.getcookie('userInfoData')).openid) {
        filtrate = 1;
        $('.classification .genderAll i').eq(0).html('Most Popular');
    }
};
var _isRequestInProgress = false; // 标志变量
var eId = null;
login_state.e_id ? eId = login_state.e_id : eId = sessionStorage.getItem('murmur');
if (!eId) {
    eId = cookie.getcookie('murmur');
};
console.log(eId, sessionStorage.getItem('murmur'));
var shawdow_mask = false;
var mask_shawdow = false;
let searchVal;
let isLoading = false;
$('.get_more .info_c').on('click', function () {
    $('#send_text').val($(this).html());
});
$('.faq_zoon .question').on('click', function () {
    $(this).parent().toggleClass('active').siblings('.faq_zoon').removeClass('active');
});
$('#clear_info').click(function () {
    $('.chat_text_box').html();
});
$('.switchBoxfalse span').click(function () {
    switchBoxtrue()
})
$('.switchBoxtrue span').click(function () {
    switchBoxfalse()
});

checkLoginStatus();
function loadImg(p) {
    let img = document.getElementsByClassName(p)
    const observer = new IntersectionObserver(changes => {
        //changes 是被观察的元素集合
        for (let i = 0, len = changes.length; i < len; i++) {
            let change = changes[i];
            // 通过这个属性判断是否在视口中
            if (change.isIntersecting) {
                const imgElement = change.target;
                imgElement.src = imgElement.getAttribute("data-avatar");
                observer.unobserve(imgElement);
            }
        }
    })
    Array.from(img).forEach(item => observer.observe(item));
};
// 获取地址栏传参
var _parmas;
if (window.location.href.indexOf('?source=') > -1) {
    _parmas = window.location.href.split('?source=')[1];
    if (_parmas.indexOf(`${lang_path}/pricing/`) > -1) {
        success(i18n[lang].public_showToast_6)
    }
} else if (!/^\d+$/.test(window.location.search)) {
    // localStorage.removeItem('source');
    // localStorage.setItem('source',window.location.origin+window.location.pathname);
}
//onlypay 支付返回状态提示
if (window.location.search.indexOf('?amount=') > -1) {
    if (window.location.search.indexOf('status=1') > -1) {
        showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_2, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
    } else if (window.location.search.indexOf('status=2') > -1) {
        showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
    } else if (window.location.search.indexOf('status=-1') > -1) {
        showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_3, '/images/toast/icon_dialogue.svg');
    }
};
//UseePay 一次性支付返回状态提示
if (window.location.search.indexOf('?getresult') > -1) {
    // 获取当前页面的URL
    const url = new URL(window.location.href);
    // 创建URLSearchParams对象
    const params = new URLSearchParams(url.search);
    // 获取指定的GET参数值
    const getresult = params.get('getresult');
    getAjax('/api/getUseePayResult', { getresult: getresult == 3 ? 3 : 1 }).then(res => {
        console.log(res.code, res.code == 200, 'xcxcxcxc');
        if (res.code == 200) {
            let items = [
                {
                    item_id: res.data.payOrderId,
                    item_name: res.data.name,
                    price: res.data.amount,
                    quantity: 1
                }
            ]
            let impactItems = [
                {
                    subTotal: res.data.amount,
                    category: res.data.name,
                    sku: res.data.payOrderId,
                    quantity: 1,
                    name: res.data.name
                },
            ];
            showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
            impactReportPrice(res.data.mchOrderNo, res.data.currency, impactItems)
            reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)

        } else if (res.code == 7011) {
            showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_2, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
        } else if (res.code == 7013) {
            showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_3, '/images/toast/icon_dialogue.svg');
        }
    })
};
// Payssion 支付返回状态提示
if (window.location.search.indexOf('transaction_id') > -1) {
    // 使用URLSearchParams对象来解析查询字符串
    const params = new URLSearchParams(window.location.search);
    // 获取transaction_id和order_id
    const transactionId = params.get('transaction_id');
    const orderId = params.get('order_id');
    console.log(transactionId, orderId);

    getAjax('/api/getPayssionResult', { transaction_id: transactionId, order_id: orderId }).then(res => {
        console.log(res.code, res.code == 200, 'xcxcxcxc');
        if (res.code == 200) {
            let items = [
                {
                    item_id: res.data.payOrderId,
                    item_name: res.data.name,
                    price: res.data.amount,
                    quantity: 1
                }
            ]
            console.log(res.data);
            let impactItems = [
                {
                    subTotal: res.data.amount,
                    category: res.data.name,
                    sku: res.data.payOrderId,
                    quantity: 1,
                    name: res.data.name
                },
            ];
            showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
            impactReportPrice(res.data.mchOrderNo, res.data.currency, impactItems)
            reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)
        } else if (res.code == 7011) {
            showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_2, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
        } else if (res.code == 7013) {
            showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_3, '/images/toast/icon_dialogue.svg');
        }
    })
};

// UseePay 订阅支付返回状态提示
// https://pre.heyreal.ai/account/profile/?id=1012501081753744454&status=succeeded&merchant_order_id=inv_1K31I1N996800
if (window.location.search.indexOf('merchant_order_id') > -1) {
    // 使用URLSearchParams对象来解析查询字符串
    const params = new URLSearchParams(window.location.search);
    // 获取transaction_id和order_id
    const merchant_order_id = params.get('merchant_order_id');
    const order_id = params.get('id');
    const status = params.get('status');

    getAjax('/api/getUseePaySubResult', { merchant_order_id, status, order_id }).then(res => {
        console.log(res.code, res.code == 200, 'xcxcxcxc');
        if (res.code == 200) {
            let items = [
                {
                    item_id: res.data.payOrderId,
                    item_name: res.data.name,
                    price: res.data.amount,
                    quantity: 1
                }
            ]
            console.log(res.data);
            let impactItems = [
                {
                    subTotal: res.data.amount,
                    category: res.data.name,
                    sku: res.data.payOrderId,
                    quantity: 1,
                    name: res.data.name
                },
            ];
            showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
            impactReportPrice(res.data.mchOrderNo, res.data.currency, impactItems)
            reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)

        } else if (res.code == 7011) {
            showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_2, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
        } else if (res.code == 7013) {
            showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_3, '/images/toast/icon_dialogue.svg');
        }
    })
};

if (window.navigationBar) {
    // 设置沉浸式导航栏的背景颜色
    window.navigationBar.backgroundColor = "#F5F6F9";
};
var _first = true;
var _first_check = true;
function resetInfo() {
    getAjax(_url.getUserInfo, { e_id: eId }).then(response => {
        if (response.code == 200) {
            try { iD('plan_bg').classList.remove('active') } catch (e) { };
            //邮箱地址
            response.data.planname ? iD('profile_plan').innerHTML = response.data.planname : null;
            response.data.plantitle ? iD('plan_detail').innerHTML = response.data.plantitle : iD('plan_detail').innerHTML = 'Premium Monthly';
            response.data.planname ? user_plan = response.data.planname : user_plan = null;
            response.data.sub_status == 1 ? $('.cancel_renewal').show() : $('.cancel_renewal').hide();

            if (response.data.planname) {
                if (response.data.planname.indexOf('Deluxe') > -1) {
                    iD('left_corn1').innerHTML = 'Unlimited';
                    iD('left_corn2').innerHTML = 'Unlimited';
                } else if (response.data.planname.indexOf('Free') > -1) {
                    iD('left_corn1').innerHTML = '0';
                    iD('left_corn2').innerHTML = '0';
                } else {
                    var _num = response.data.message_num - response.data.usage;
                    if (_num <= 0) {
                        _num = 0;
                    }
                    iD('left_corn1').innerHTML = _num;
                    iD('left_corn2').innerHTML = _num;
                }
            } else {

            };
            if (response.data.planname == 'Free' && response.data.remaining_num) {
                iD('message').innerHTML = 'Bonus Messages:';
                response.data.remaining_num ? iD('user_plan_num').innerHTML = response.data.remaining_num : iD('user_plan_num').innerHTML = '0';
            } else if (response.data.planname != 'Free' && response.data.message_num) {
                iD('message').innerHTML = 'Subscription Messages:';
                if (response.data.planname.indexOf('Deluxe') > -1) {
                    iD('user_plan_num').innerHTML = 'Unlimited';
                } else {
                    response.data.remaining_num ? iD('user_plan_num').innerHTML = response.data.message_num - response.data.usage : iD('user_plan_num').innerHTML = '0';
                }
            };
            response.data.expire ? iD('plan_expired').innerHTML = response.data.expire : null;
            response.data.fans_num && response.data.fans_num >= 0 ? iD('profile_followers').innerHTML = autoNumberTransform(response.data.fans_num) : null;
            response.data.follow_num && response.data.follow_num >= 0 ? iD('profile_following').innerHTML = autoNumberTransform(response.data.follow_num) : null;
            response.data.fans_num == 0 ? $('.followerMetalMask .info').show() : null;
            response.data.follow_num == 0 ? $('.followingMetalMask .info').show() : null;
            response.data.remaining_num ? iD('bonus_corn').innerHTML = response.data.remaining_num : iD('bonus_corn').innerHTML = '0';
            response.data.remaining_num ? iD('bonus_corn1').innerHTML = response.data.remaining_num : iD('bonus_corn1').innerHTML = '0';
            response.data.title_icon ? iD('personal_metal_info').style.backgroundImage = 'url(' + response.data.title_icon + ')' : null;
            response.data.title ? iD('personal_metal_info').setAttribute('title', response.data.title) : null;
            response.data.title && response.data.title_icon ? iD('personal_metal_info').classList.add('active') : null;
            //剩余聊天数
            if (response.data.planname) {
                if (response.data.planname.indexOf('Deluxe') > -1) {
                    document.querySelectorAll('.total_corn').forEach(function (box) {
                        box.innerHTML = '';
                    });
                    iD('num_unused').innerHTML = 'Ultimate';
                } else if (response.data.planname.indexOf('Free') > -1) {
                    document.querySelectorAll('.total_corn').forEach(function (box) {
                        box.innerHTML = '';
                    });
                    iD('num_unused').innerHTML = '0';
                } else {
                    document.querySelectorAll('.total_corn').forEach(function (box) {
                        box.innerHTML = '/' + response.data.message_num;
                    });
                    iD('num_unused').innerHTML = response.data.message_num - response.data.usage;
                }
            } else {

            };
            try {
                response.data.item_card_num > -1 && response.data.item_card_num < 10000 ? iD('remain_unlock').innerHTML = response.data.item_card_num : response.data.item_card_num > -1 && response.data.item_card_num >= 10000 ? iD('remain_unlock').innerHTML = '9999+' : null;
                response.data.item_card_num > -1 && response.data.item_card_num < 10000 ? iD('remain_unlock1').innerHTML = response.data.item_card_num : response.data.item_card_num > -1 && response.data.item_card_num >= 10000 ? iD('remain_unlock1').innerHTML = '9999+' : null;
            } catch (e) { }
            if (response.data.social_links) {
                for (var udd in response.data.social_links) {
                    try { iD('a_' + udd).classList.remove('active') } catch (e) { }
                    response.data.social_links[udd] ? iD('a_' + udd).classList.add('active') : null;
                    response.data.social_links[udd] ? iD('a_' + udd).setAttribute('href', response.data.social_links[udd]) : null;
                }
            };
            var userInfoData = response.data;
            userInfoData.eid = eId;
            response.data ? cookie.setcookie('userInfoData', JSON.stringify(userInfoData), 90) : null;
        } else if (response.error == 20901) {
            _error(i18n[lang].error_20901);
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        } else if (response.error == 20902) {
            _error(i18n[lang].error_20902);
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        } else if (response.code == 204) {
            setTimeout(function () {
                window.location.href = `${lang_path}/account/login/`
            }, 3000);
        }
    });
};
var userInfoUid;
cookie.getcookie('userInfoData') ? userInfoUid = JSON.parse(cookie.getcookie('userInfoData')).uid : userInfoUid = null;
// 点赞收藏 
var _creatFlags = false;
function create_like(roleid, uid, status, num, element, _creatFlags) {
    var starTime = new Date().getTime();
    if (!_creatFlags) {
        _creatFlags = true;
        getAjax(_url.likesUpdate, {
            "roleid": roleid,
            "be_liked_id": uid,
            "status": status
        }).then(res => {
            const responseDate = new Date().getTime();
            if (responseDate - starTime >= 5000) {
                _creatFlags = false;
            } else {
                setTimeout(function () {
                    _creatFlags = false;
                }, 5000 - (responseDate - starTime));
            };
            if (res.code == 200) {
                if (status) {
                    num++;
                    success(i18n[lang].public_Successfully_Like)
                } else {
                    num--;
                    success(i18n[lang].public_Successfully_Unlike);
                }
                element.next().html(autoNumberTransform(num));
                element.attr('like-num', num);
            } else {
                if (status) {
                    error(i18n[lang].public_Failed_Like)
                } else {
                    error(i18n[lang].public_Failed_Unlike);
                }
            }
        }).catch(res => {
            if (status) {
                error(i18n[lang].public_Failed_Like)
            } else {
                error(i18n[lang].public_Failed_Unlike);
            }
        });
    } else if (_creatFlags) {
        error(i18n[lang].public_too_fast);
    }
};
$('.profile_error_inner i').on('click', function (e) {
    e.stopPropagation();
    $('#profile_error').removeClass('active');
    getAjax(_url.updateReportLevel, { 'report_level': JSON.parse(cookie.getcookie('userInfoData')).report_level }).then(res => {
        if (res.code == 200) {
        } else {
            error(i18n[lang].public_Something_wrong);
        }
    });
});
if ($(window).width() < 769) {
    $('.ivu-layout-content').removeClass('scrollLogic').css({ 'overflowY': 'auto', 'width': '100%' });
    $('html').addClass('scrollLogic').addClass('scroll-active').css({ 'overflowY': 'scroll', 'background': '#f5f6f9' });
    $('.layout-header').css({ 'position': 'fixed', 'top': 0, 'zIndex': 99, 'width': '100%', 'box-sizing': 'border-box' });
    defaultDisplayOfScrollbar();
};
//resetInfo();
if (_first) {
    if (!shawdow_mask) {
        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        $('.main_right .ivu-row.chatContent').eq(1).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        $('.main_right .ivu-row.chatContent').eq(2).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
    };
    shawdow_mask = true;
    setTimeout(function () {
        //第一个盒子渲染
        getAjax(`/api/userRobotLists`, {
            e_id: eId,
            pageNum: page_num.characters,
            filtrate: filtrate,
        }).then(res => {
            if (res.code == 200) {

                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).find('.load_more').remove();
                page_num.characters_total = res.total;
                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).empty();
                if (res.data.length >= 1) {
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.characters_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}_1" data-roleid="${response.roleid}">
                                <div class="character-img-box">
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar ${(response.ex_status == 0 || response.ex_status == 3) ? 'blur-status' : ''}" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.ex_status == 2 ? `<span class="character-status private"><i></i>${i18n[lang].public_Private}</span>` : response.ex_status == 3 ? `<span class="character-status restricted"><i></i>${i18n[lang].public_Restricted_Display}</span>` : response.ex_status == 0 ? `<span class="character-status"><i></i>${i18n[lang].public_Under_Review}</span>` : ''}
                                
                                         </div> 
                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_1">${response.name}</span>
                                <p class="creator">by <span id="profile${response.roleid}_1" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                    <div class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}" title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                        ${escapeHtml(response.describe) || ''}
                                    </div>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                            </div>`);
                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_1`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        }
                        $(`#name${response.roleid}_1`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`.other_options${response.roleid}_1`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_1 .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_1 .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_1 .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                    });
                } else {
                    const emptyElement = $(`
                                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                    </div>
                                `)
                    if (!$('.innerContent').eq(0).find('.show_result').length) {
                        $('.innerContent').eq(0).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    page_num.characters++;
                    isLoading = false;
                    if (res.data.length > 1 && page_num.characters_total > page_num.characters_num) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)

            }
        });
        getAjax(`/api/userRobotLists`, {
            e_id: eId,
            pageNum: page_num.public,
            filtrate: filtrate,
            robot_type: 0
        }).then(res => {
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).find('.load_more').remove();
                page_num.public_total = res.total;
                if (res.data.length >= 1) {
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.public_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                        <a href="/chat/${response.roleid}" id="robot${response.roleid}_2" class="item homeItemInPHP robot${response.roleid}_2" data-roleid="${response.roleid}"> 
                        <div class="character-img-box">
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar ${(response.ex_status == 0 || response.ex_status == 3) ? 'blur-status' : ''}" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                             ${response.ex_status == 2 ? `<span class="character-status private"><i></i>${i18n[lang].public_Private}</span>` : response.ex_status == 3 ? `<span class="character-status restricted"><i></i>${i18n[lang].public_Restricted_Display}</span>` : response.ex_status == 0 ? `<span class="character-status"><i></i>${i18n[lang].public_Under_Review}</span>` : ''}
                                
                                         </div> 
                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_2">${response.name}</span>
                                <p class="creator">by <span id="profile${response.roleid}_2" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                            <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                            title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                ${escapeHtml(response.describe) || ''}
                            </p>
                            <div class="flex-col-between">
                                ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                    <ul class="tagsBox">
                                        ${JSON.parse(response.tagsid).map((item, key) => `
                                            <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                ${item.name}
                                            </li>
                                        `).join('')}
                                    </ul>
                                ` : '<div class="tagsBox"></div>'}
                                <div class="bottom cen flex_box"> 
                                    <div class="bottomItem">
                                        <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                        <span>${_like_num}</span>
                                    </div> 
                                    <div class="bottomItem">
                                        <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                        <span>${_chats_num}</span>
                                    </div> 
                                    ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_2"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_2"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                </div>
                            </div>
                        </a>
                        </div>`);
                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_2`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        }
                        $(`#name${response.roleid}_2`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`.other_options${response.roleid}_2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_2 .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_2`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_2 .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_2`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_2 .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                    });
                } else {
                    const emptyElement = $(`
                            <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                    if (!$('.innerContent').eq(1).find('.show_result').length) {
                        $('.innerContent').eq(1).append(emptyElement);
                    }
                };
                addLoad();
                setTimeout(() => {
                    page_num.public++;
                    isLoading = false;
                    if (res.data.length > 1 && page_num.public_total > page_num.public_num) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)
            }
        });
        getAjax(`/api/userRobotLists`, {
            e_id: eId,
            pageNum: page_num.private,
            filtrate: filtrate,
            robot_type: 1
        }).then(res => {
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).find('.load_more').remove();
                if (res.data.length >= 1) {
                    page_num.private_total = res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.private_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                        <a href="/chat/${response.roleid}" id="robot${response.roleid}_3" class="item homeItemInPHP robot${response.roleid}_3" data-roleid="${response.roleid}"> 
                            <div class="character-img-box">
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar ${(response.ex_status == 0 || response.ex_status == 3) ? 'blur-status' : ''}" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                    ${response.ex_status == 2 ? `<span class="character-status private"><i></i>${i18n[lang].public_Private}</span>` : response.ex_status == 3 ? `<span class="character-status restricted"><i></i>${i18n[lang].public_Restricted_Display}</span>` : response.ex_status == 0 ? `<span class="character-status"><i></i>${i18n[lang].public_Under_Review}</span>` : ''}
                                
                                         </div> 
                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_3">${response.name}</span>
                                <p class="creator">by <span id="profile${response.roleid}_3" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                            <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                            </p>
                            <div class="flex-col-between">
                                ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                    <ul class="tagsBox">
                                        ${JSON.parse(response.tagsid).map((item, key) => `
                                            <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                ${item.name}
                                            </li>
                                        `).join('')}
                                    </ul>
                                ` : '<div class="tagsBox"></div>'}
                                <div class="bottom cen flex_box"> 
                                    <div class="bottomItem">
                                        <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                        <span>${_like_num}</span>
                                    </div> 
                                    <div class="bottomItem">
                                        <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                        <span>${_chats_num}</span>
                                    </div> 
                                    ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_3"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_3"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                </div>
                            </div>
                        </a>
                        </div>`);
                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_3`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        }
                        $(`#name${response.roleid}_3`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`.other_options${response.roleid}_3`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_3 .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_3`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_3 .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_3`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_3 .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                    });
                } else {
                    const emptyElement = $(`
                            <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                    if (!$('.innerContent').eq(2).find('.show_result').length) {
                        $('.innerContent').eq(2).append(emptyElement);
                    }
                };
                addLoad();
                setTimeout(() => {
                    page_num.private++;
                    isLoading = false;
                    if (res.data.length > 1 && page_num.private_total > page_num.private_num) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)
            }
        });
        //故事story渲染
        getAjax(_url.personStoryList, {
            "type": 1,
            "order": filtrate,
            "page": 1,
        }).then(res => {
            $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).empty();
                $('.style_card').on('click', function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                if (res.data.length >= 1) {
                    // page.characters_total=res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        // page.characters_num++;
                        page_num.storys_num++;
                        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });

                    });
                } else {
                    const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                    if (!$('.chat-story-content .innerContent').eq(0).find('.show_result').length) {
                        $('.chat-story-content .innerContent').eq(0).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    page_num.storys++;
                    // story_list_page.characters++;
                    isLoading = false;
                    // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                    if (res.data.length > 1) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    // $('#searchInput').val('');
                    bindScroll();
                }, 1500)
            } else {
                const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                if (!$('.chat-story-content .innerContent').eq(0).find('.show_result').length) {
                    $('.chat-story-content .innerContent').eq(0).append(emptyElement);
                }
            }
            isRequestInProgressStory = false;
        }).catch(err => {
            isRequestInProgressStory = false;
        });
        getAjax(_url.personStoryList, {
            "type": 2,
            "order": filtrate,
            "page": 1,
        }).then(res => {
            $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).empty();
                $('.style_card').on('click', function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                if (res.data.length >= 1) {
                    // page.characters_total=res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        // page.characters_num++;
                        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });

                    });
                } else {
                    const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                    if (!$('.chat-story-content .innerContent').eq(1).find('.show_result').length) {
                        $('.chat-story-content .innerContent').eq(1).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    // story_list_page.characters++;
                    page_num.storys_public++;
                    isLoading = false;
                    // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                    if (res.data.length > 1) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    // $('#searchInput').val('');
                    bindScroll();
                }, 1500)
            } else {
                const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                if (!$('.chat-story-content .innerContent').eq(1).find('.show_result').length) {
                    $('.chat-story-content .innerContent').eq(1).append(emptyElement);
                }
            }
            isRequestInProgressStory = false;
        }).catch(err => {
            isRequestInProgressStory = false;
        });
        getAjax(_url.personStoryList, {
            "type": 3,
            "order": filtrate,
            "page": 1,
        }).then(res => {
            $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).empty();
                $('.style_card').on('click', function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                if (res.data.length >= 1) {
                    // page.characters_total=res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        // page.characters_num++;
                        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });

                    });
                } else {
                    const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                    if (!$('.chat-story-content .innerContent').eq(2).find('.show_result').length) {
                        $('.chat-story-content .innerContent').eq(2).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    // story_list_page.characters++;
                    page_num.storys_private++;
                    isLoading = false;
                    // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                    if (res.data.length > 1) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    // $('#searchInput').val('');
                    bindScroll();
                }, 1500)
            } else {
                const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                if (!$('.chat-story-content .innerContent').eq(2).find('.show_result').length) {
                    $('.chat-story-content .innerContent').eq(2).append(emptyElement);
                }
            }
            isRequestInProgressStory = false;
        }).catch(err => {
            isRequestInProgressStory = false;
        });

        //收藏角色渲染
        getAjax('/api/getCollectLists', { "pageNum": page_num.favorites }).then(res => {
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).find('.load_more').remove();
                page_num.favorites_total = res.total;
                if (res.data.length >= 1) {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).empty();
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.favorites_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        // if(response.robot_type==0||response.isdel==1){
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                        <a href="/chat/${response.roleid}" id="robot${response.roleid}_4" class="item homeItemInPHP" data-roleid="${response.roleid}"> 
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                    <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                    <p class="creator">by <span id="profile${response.roleid}" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && userInfoUid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                    <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                                    </p>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                            </div>`)

                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_4`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        };
                        $(`#name${response.roleid}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`#profile${response.roleid}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl($(this).attr('action-href'));
                        });
                        $(`.other_options${response.roleid}_4`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_4 .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_4 .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_4 .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                        if ($(`#robot${response.roleid}_4 .profile_card`).length > 0) {
                            $(`#robot${response.roleid}_4 .profile_card`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                    if (res.code == 200) {
                                        $('.profileMetalMask').addClass('active');
                                        $('.profileMetal').addClass('active');
                                        $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                        $('.profile_metal_list').empty();
                                        $('.profileMetalInfo').remove();
                                        res.data.forEach(item => {
                                            $('.profile_metal_list').append(`
                                            <div class="profile_metal_item" attr-id="${item.id}">
                                                <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                <p class="title metal_title">${item.title}</p>
                                            </div>
                                            `);
                                            $('.profile_metal_container').after(`
                                            <p class="profileMetalInfo">${item.desc}</p>
                                            `);
                                        });
                                        $('.profile_metal_item').eq(0).addClass('active');
                                        $('.profileMetalInfo').eq(0).addClass('active');
                                        $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                    } else {
                                        error(i18n[lang].public_Failed_Show_Achievements)
                                    }
                                });
                            });
                        }
                        // }
                    });
                } else {
                    const emptyElement = $(`
                                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                    </div>
                                `)

                    if (!$('.favorites-content .innerContent').eq(0).find('.show_result').length) {
                        $('.favorites-content .innerContent').eq(0).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    page_num.favorites++;
                    isLoading = false;
                    if (res.data.length > 1 && page_num.favorites_total > page_num.favorites_num) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)
            }
        });
        //收藏story渲染
        getAjax(_url.getStoryCollectList, {
            "pageNum": 1,
        }).then(res => {
            $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).empty();
                $('.style_card').on('click', function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                if (res.data.length >= 1) {
                    // page.characters_total=res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        // page.characters_num++;
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });

                    });
                } else {
                    const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                    if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                        $('.favorites-content .innerContent').eq(1).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    // story_list_page.characters++;
                    isLoading = false;
                    // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                    if (res.data.length > 1) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    // $('#searchInput').val('');
                    bindScroll();
                }, 1500)
            } else {
                const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                    $('.favorites-content .innerContent').eq(1).append(emptyElement);
                }
            }
            isRequestInProgressStory = false;
        }).catch(err => {
            isRequestInProgressStory = false;
        });
        //喜欢角色渲染
        getAjax('/api/getLikesLists', { "pageNum": page_num.likes }).then(res => {
            if (res.code == 200) {
                // $('.main_right .ivu-row.chatContent').eq(3).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).find('.load_more').remove();
                page_num.likes_total = res.total;
                if (res.data.length >= 1) {
                    // $('.main_right .ivu-row.chatContent').eq(3).empty();
                    $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).empty();

                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.likes_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        // if(response.robot_type==0||response.isdel==1){

                        $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_5" class="item homeItemInPHP" data-roleid="${response.roleid}"> 
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                    <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                    <p class="creator">by <span id="profile${response.roleid}" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && userInfoUid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                    <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                                    </p>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                            </div>`)

                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_5`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        };
                        $(`#name${response.roleid}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`#profile${response.roleid}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl($(this).attr('action-href'));
                        });
                        $(`.other_options${response.roleid}_5`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_5 .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_5 .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_5 .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                        if ($(`#robot${response.roleid}_5 .profile_card`).length > 0) {
                            $(`#robot${response.roleid}_5 .profile_card`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                    if (res.code == 200) {
                                        $('.profileMetalMask').addClass('active');
                                        $('.profileMetal').addClass('active');
                                        $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                        $('.profile_metal_list').empty();
                                        $('.profileMetalInfo').remove();
                                        res.data.forEach(item => {
                                            $('.profile_metal_list').append(`
                                            <div class="profile_metal_item" attr-id="${item.id}">
                                                <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                <p class="title metal_title">${item.title}</p>
                                            </div>
                                            `);
                                            $('.profile_metal_container').after(`
                                            <p class="profileMetalInfo">${item.desc}</p>
                                            `);
                                        });
                                        $('.profile_metal_item').eq(0).addClass('active');
                                        $('.profileMetalInfo').eq(0).addClass('active');
                                        $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                    } else {
                                        error(i18n[lang].public_Failed_Show_Achievements)
                                    }
                                });
                            });
                        }
                        // }
                    });
                } else {
                    const emptyElement = $(`
                                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                    </div>
                                `)
                    if (!$('.likes-content .innerContent').eq(0).find('.show_result').length) {
                        $('.likes-content .innerContent').eq(0).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    $('.chatContent #loadBox').hide();
                    page_num.likes++;
                    if (res.data.length > 1 && page_num.likes_total > page_num.likes_num) { shawdow_mask = false };
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)
            }
        });
        //喜欢story渲染
        getAjax(_url.likeStoryList, {
            "type": 2,
            "order": filtrate,
            "page": 1,
        }).then(res => {
            $('.main_right .ivu-row.chatContent').eq(3).find('.load_more').remove();
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).find('.load_more').remove();
                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).empty();
                $('.style_card').on('click', function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                if (res.data.length >= 1) {
                    // page.characters_total=res.total;
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        // page.characters_num++;
                        $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });

                    });
                } else {
                    const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                    if (!$('.likes-content .innerContent').eq(1).find('.show_result').length) {
                        $('.likes-content .innerContent').eq(1).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    // story_list_page.characters++;
                    isLoading = false;
                    // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                    if (res.data.length > 1) { shawdow_mask = false };
                    $('.chatContent #loadBox').hide();
                    // $('#searchInput').val('');
                    bindScroll();
                }, 1500)
            } else {
                const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                if (!$('.likes-content .innerContent').eq(1).find('.show_result').length) {
                    $('.likes-content .innerContent').eq(1).append(emptyElement);
                }
            }
            isRequestInProgressStory = false;
        }).catch(err => {
            isRequestInProgressStory = false;
        });
        _first = false;
    }, 3000);
};
async function updateUserPlan() {
    try {
        await getAjax(_url.updateUserChargebeePlan)
    } catch (err) {
        console.log(err)
    }
    await resetInfo();
    // if (getQueryVariable('amount')) {
    //     reportPrice('purchase', {
    //         transaction_id: getQueryVariable('payOrderId'),
    //         value: parseFloat(getQueryVariable('amount')),
    //         tax: 0.00,
    //         shipping: 0.00,
    //         coupon: "",
    //         currency: getQueryVariable('currency'),
    //         items: [
    //             {
    //                 item_id: getQueryVariable('mchOrderNo'),
    //                 item_name: 'HeyReal Chat Service',
    //                 price: parseFloat(getQueryVariable('amount')),
    //                 item_category: "HeyReal Chat",
    //                 item_variant: "no options",
    //                 quantity: 1
    //             }
    //         ]
    //     });
    // }
};

let automaticDetection = true;
if (getQueryVariable('sub_id')) {
    $('body').append(`
        <div class="countDown">
            <p>We are checking your payment status, please be patient and do not close this page.</p>
            <p><img src="/images/account/loading_pur.svg" alt="Loading" width="24" height="24"/><span class="countNum">10</span>s</p>
        </div>
    `);
    var countDownNum = 10;
    var countDownElement = $('.countDown .countNum');
    var interval = setInterval(updateCountdown, 1000);
    let autoTime = setTimeout(() => {
        automaticDetection = false;
        clearInterval(interval);
        $('.countDown').remove();
    }, 10000);
};
function updateCountdown() {
    countDownElement.text(countDownNum);
    if (countDownNum > 0) {
        countDownNum--;
        $('.countNum').html(countDownNum)
    } else {
        clearInterval(interval);
        // 倒计时结束后自动执行的动作
        automaticDetection = false;
        $('.countDown').remove();
    }
}
if (getQueryVariable('subscription_id')) {
    getPalPayResult()
};
// 请求PayPal支付结果 
function getPalPayResult() {
    getAjax('/api/getPalPayResult', {
        url: location.href,
    }).then(res => {
        if (res.code == 200) {
            success(i18n[lang].public_showToast_6);
            resetInfo();
            // reportTransaction(transactionId, affiliation, totalValue, taxValue, shipping, currency,items)
            //参数相关文档链接 https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=zh-cn&client_type=gtag

            let items = [
                {
                    item_id: res.data.payOrderId,
                    item_name: res.data.name,
                    price: res.data.amount,
                    quantity: 1
                }
            ]
            let impactItems = [
                {
                    subTotal: res.data.amount,
                    category: res.data.name,
                    sku: res.data.payOrderId,
                    quantity: 1,
                    name: res.data.name
                },
            ];
            impactReportPrice(res.data.mchOrderNo, res.data.currency, impactItems)
            reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)
        } else if (res.code == 7011) {
            showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_5, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
        } else {
            error(i18n[lang].public_Network_error);
        }

    });
};
async function checkoutChargee(subId) {
    let email = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).email : null;
    let productId = cookie.getcookie('planID');
    addInfoSection();
    let checkoutRes = await getAjax(_url.chargebeeCheckout, { email: email, subscriptionId: subId, productId: productId });
    if (automaticDetection) {
        if (checkoutRes.code == 200) {
            await resetInfo();
            automaticDetection = false;
            interval && clearInterval(interval);
            $('.countDown') && $('.countDown').remove();
        } else {
            setTimeout(() => {
                checkoutChargee(subId)
            }, 1000)
        }
        $('.total_messages .tempTotalMessages').remove();
        $('.plan_zoon .tempProfilePlan').remove();
        $('.user_name .tempUserName').remove();
    } else {
        if (checkoutRes.code == 200) {
            $('.popMask').hide();
        } else {
            addVerifityPop();
        }
        await resetInfo();
        $('.total_messages .tempTotalMessages').remove();
        $('.plan_zoon .tempProfilePlan').remove();
        $('.user_name .tempUserName').remove();
    }
}
function addInfoSection() {
    $('.total_messages').append('<div class="tempTotalMessages"><p></p></div>')
    $('.plan_zoon').append('<div class="tempProfilePlan"><p></p></div>')
    $('.user_name').append('<i class="tempUserName"><em></em></i>')
    $('.tempTotalMessages').length && $('.tempTotalMessages').scheletrone({
        url: '', // 不请求数据
        ajaxData: {}, // 空数据
        debug: {
            log: false,
            latency: 0 // 无延迟
        },
        removeIframe: false, // 不移除 iframe
        maskText: true, // 掩盖文本内容
        skelParentText: false, // 不掩盖父元素文本
        backgroundImage: false, // 处理背景图片
        selector: 'p', // 选择 .item 作为骨架图展示目标
        incache: false, // 不缓存数据
        onComplete: function () {

        }
    });
    $('.tempProfilePlan').length && $('.tempProfilePlan').scheletrone({
        url: '', // 不请求数据
        ajaxData: {}, // 空数据
        debug: {
            log: false,
            latency: 0 // 无延迟
        },
        removeIframe: false, // 不移除 iframe
        maskText: true, // 掩盖文本内容
        skelParentText: false, // 不掩盖父元素文本
        backgroundImage: false, // 处理背景图片
        selector: 'p', // 选择 .item 作为骨架图展示目标
        incache: false, // 不缓存数据
        onComplete: function () {

        }
    });
    $('.tempUserName').length && $('.tempUserName').scheletrone({
        url: '', // 不请求数据
        ajaxData: {}, // 空数据
        debug: {
            log: false,
            latency: 0 // 无延迟
        },
        removeIframe: false, // 不移除 iframe
        maskText: true, // 掩盖文本内容
        skelParentText: false, // 不掩盖父元素文本
        backgroundImage: false, // 处理背景图片
        selector: 'em', // 选择 .item 作为骨架图展示目标
        incache: false, // 不缓存数据
        onComplete: function () {

        }
    });
}
function addVerifityPop() {
    if ($('.main_section .popMask').length > 0) {
        $('.popMask').hide();
    }
    $('.popMask').show();
    document.querySelector('.verCancel').addEventListener('click', () => {
        window.open('https://discord.com/invite/aXvBRYtP2A', '__blank')
    })
    let closeButton = document.querySelectorAll('.close');
    closeButton[0].addEventListener('click', function () {
        $('.popMask').hide();
    })
    document.querySelector('.verPaid').addEventListener('click', async () => {
        $('.verPaid img').show();
        await checkoutChargee(getQueryVariable('sub_id'))
        $('.verPaid img').hide();
    })
}
function addLoad() {
    if ($('#loadBox').length === 0) {
        $('.chatContent').append($(`<div id="loadBox" style="display: none;position: absolute; left: 0; right: 0; top: 0; height: 100%; z-index: 10;background: #f5f6f9;"><div class="loadanimation" style="position: absolute; top: 6.25rem; left: 50%; transform: translateX(-50%);z-index: 100;"></div></div>`))
    }
}
addLoad();
// 解除绑定 scroll 事件
function unbindScroll() {
    $('.layout-content').off('scroll', handleScroll);
}

// 重新绑定 scroll 事件
function bindScroll() {
    $('.layout-content').on('scroll', handleScroll);
}

// 定义 scroll 事件处理函数
function handleScroll() {
    const scrollTop = $(this).scrollTop();
    const scrollHeight = $(this).prop('scrollHeight');
    const clientHeight = $(this).height();
    if (scrollTop + clientHeight >= scrollHeight - 500) {
        loadMore();
    }
}
bindScroll();
function loadMore() {
    // if(!shawdow_mask){$('.loadingMask').show();}
    // else{$('.load_more').remove();}
    if (isLoading || _first) return;
    isLoading = true;
    if ($('.my_card').eq(0).attr('class').indexOf('active') > -1) {
        if ($('.chatContent.active .itemDiv').length < 50) {
            $('.load_more').remove(); return;
        } else {
            if ($('.style_card').eq(0).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax('/api/userRobotLists', {
                    e_id: eId,
                    pageNum: page_num.characters,
                    robot_type: robot_type,
                    filtrate: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.characters_total=res.total;
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            page_num.characters_num++;
                            var _like_num, _chats_num;
                            response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                            response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                            $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(0).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                        <a href="/chat/${response.roleid}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}_1" data-roleid="${response.roleid}"> 
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                        <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_1">${response.name}</span>
                                        <p class="creator">by <span id="profile${response.roleid}_1" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                    <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                        ${escapeHtml(response.describe) || ''}
                                    </p>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                            </div>`);

                            const image = new Image();
                            image.src = response.avatar_url
                            image.onload = function () {
                                var $img = $(`#robot${response.roleid}_1`).find('.img');
                                if ($img.length) {
                                    $img.attr('src', image.src);
                                    var oAbc = $img[0].getBoundingClientRect();
                                    if (oAbc.width) {
                                        $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                    } else {
                                        $img.attr({ 'width': image.width, 'height': image.height });
                                    }
                                } else {
                                    console.error('Image element not found for roleid:', response.roleid);
                                }
                            };
                            $(`#name${response.roleid}_1`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                redirectToUrl(`${lang_path}/character/${response.roleid}`);
                            });
                            $(`.other_options${response.roleid}_1`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                    $(this).find('i').removeClass('active').siblings().removeClass('active');
                                } else {
                                    $(document).trigger('click');
                                    $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                }
                            });
                            $(`.other_options${response.roleid}_1 .report`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    report_arguments(response.roleid, response.name, response.nsfw);
                                }
                            });
                            $(`.other_options${response.roleid}_1 .character_edit`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    redirectToUrl($(this).attr('action-href'));
                                }
                            });
                            $(`#robot${response.roleid}_1 .icon-icon_like2`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                var that = $(this);
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    that.toggleClass('active');
                                    var _num = that.attr('like-num');
                                    if (that.hasClass('active')) {
                                        create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                    } else {
                                        create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                    }
                                }
                            });
                        });
                        addLoad();
                        setTimeout(() => {
                            page_num.characters++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.characters_total > page_num.characters_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        if (!$('.innerContent').eq(0).find('.show_result').length) {
                            $('.innerContent').eq(0).append(emptyElement);
                        }
                    };
                });
            } else if ($('.style_card').eq(1).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax(`/api/userRobotLists`, {
                    e_id: eId,
                    pageNum: page_num.public,
                    robot_type: 0,
                    filtrate: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.public_total=res.total;
                        if (res.data.length >= 1) {
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page_num.public_num++;

                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_2" class="item homeItemInPHP robot${response.roleid}_2" data-roleid="${response.roleid}"> 
                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                    data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                            <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_2">${response.name}</span>
                            <p class="creator">by <span id="profile${response.roleid}_2" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                    ${escapeHtml(response.describe) || ''}
                                </p>
                                <div class="flex-col-between">
                                    ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                        <ul class="tagsBox">
                                            ${JSON.parse(response.tagsid).map((item, key) => `
                                                <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                    ${item.name}
                                                </li>
                                            `).join('')}
                                        </ul>
                                    ` : '<div class="tagsBox"></div>'}
                                    <div class="bottom cen flex_box"> 
                                        <div class="bottomItem">
                                            <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                            <span>${_like_num}</span>
                                        </div> 
                                        <div class="bottomItem">
                                            <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                            <span>${_chats_num}</span>
                                        </div> 
                                        ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_2"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_2"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                    </div>
                                </div>
                            </a>
                            </div>`);

                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_2`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $img.attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}_2`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`.other_options${response.roleid}_2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_2 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_2`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_2 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_2`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_2 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                            });
                        } else {
                            const emptyElement = $(`
                            <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                            if (!$('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).find('.show_result').length) {
                                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(emptyElement);
                            }
                        };
                        addLoad();
                        setTimeout(() => {
                            page_num.public++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.public_total > page_num.public_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                        <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                        if (!$('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).find('.show_result').length) {
                            $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(1).append(emptyElement);
                        }
                    };
                });
            } else if ($('.style_card').eq(2).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax(`/api/userRobotLists`, {
                    e_id: eId,
                    pageNum: page_num.private,
                    robot_type: 1,
                    filtrate: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.private_total=res.total;
                        if (res.data.length >= 1) {
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page_num.private_num++;

                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_3" class="item homeItemInPHP robot${response.roleid}_3" data-roleid="${response.roleid}"> 
                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                    data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                            <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_3">${response.name}</span>
                            <p class="creator">by <span id="profile${response.roleid}_3" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                    ${escapeHtml(response.describe) || ''}
                                </p>
                                <div class="flex-col-between">
                                    ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                        <ul class="tagsBox">
                                            ${JSON.parse(response.tagsid).map((item, key) => `
                                                <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                    ${item.name}
                                                </li>
                                            `).join('')}
                                        </ul>
                                    ` : '<div class="tagsBox"></div>'}
                                    <div class="bottom cen flex_box"> 
                                        <div class="bottomItem">
                                            <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                            <span>${_like_num}</span>
                                        </div> 
                                        <div class="bottomItem">
                                            <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                            <span>${_chats_num}</span>
                                        </div> 
                                        ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_3"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_3"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                    </div>
                                </div>
                            </a>
                            </div>`);

                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_3`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $img.attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}_3`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`.other_options${response.roleid}_3`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_3 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_3`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_3 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_3`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_3 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                            });
                        }
                        addLoad();
                        setTimeout(() => {
                            page_num.private++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.private_total > page_num.private_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                    <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                    <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                </div>
            `)
                        if (!$('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).find('.show_result').length) {
                            $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(emptyElement);
                        }
                    };
                });
            }
        }
    } else if ($('.my_card').eq(1).attr('class').indexOf('active') > -1) {
        if ($('.chatContent.active .itemDiv').length < 20) {
            $('.load_more').remove(); return;
        } else {
            if ($('.story_card').eq(0).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax(_url.personStoryList, {
                    page: page_num.storys,
                    type: 1,
                    order: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.characters_total=res.total;
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            page_num.storys_num++;
                            var _like_num, _chats_num;
                            response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                            response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                            $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).append(`
                         <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                        <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                            <div class="story-title">${response.title}</div>
                                            <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                            <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                            <div class="story-msg">
                                                <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                            </div>
                                        </a>
                                    </div>`)
                            $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if ($(this).data('anonymoustype') == 1) {
                                    console.log(response.users.openid, 'response.users.openid');
                                    error(i18n[lang].public_story_anonymous)
                                } else {
                                    redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                }
                            });
                        });
                        addLoad();
                        setTimeout(() => {
                            page_num.storys++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.storys_total > page_num.storys_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        if (!$('.chat-story-content .innerContent').eq(0).find('.show_result').length) {
                            $('.chat-story-content .innerContent').eq(0).append(emptyElement);
                        }
                    };
                });
            } else if ($('.story_card').eq(1).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax(_url.personStoryList, {
                    page: page_num.storys_public,
                    type: 2,
                    order: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.public_total=res.total;
                        if (res.data.length >= 1) {
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page_num.storys_public_num++;

                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                        <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                            <div class="story-title">${response.title}</div>
                                            <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                            <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                            <div class="story-msg">
                                                <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                            </div>
                                        </a>
                                    </div>`)
                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });
                            });
                        } else {
                        //     const emptyElement = $(`
                        //     <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                        //         <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        //         <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        //     </div>
                        // `)
                        //     if (!$('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).find('.show_result').length) {
                        //         $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).append(emptyElement);
                        //     }
                        };
                        addLoad();
                        setTimeout(() => {
                            page_num.storys_public++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.storys_public_total > page_num.storys_public_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                        <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                        // if (!$('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).find('.show_result').length) {
                        //     $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(1).append(emptyElement);
                        // }
                    };
                });
            } else if ($('.story_card').eq(2).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax(_url.personStoryList, {
                    page: page_num.storys_private,
                    type: 3,
                    order: filtrate
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page_num.private_total=res.total;
                        if (res.data.length >= 1) {
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page_num.private_num++;

                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(2).append(`
                          <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                        <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                            <div class="story-title">${response.title}</div>
                                            <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                            <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                            <div class="story-msg">
                                                <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                            </div>
                                        </a>
                                    </div>`)
                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });
                            });
                        }
                        addLoad();
                        setTimeout(() => {
                            page_num.storys_private++;
                            isLoading = false;
                            if (res.data.length > 1 && page_num.storys_private_total > page_num.storys_private_num) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            $('#searchInput').val('');
                            addTooltip();
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                    <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                    <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                </div>
            `)
                        if (!$('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).find('.show_result').length) {
                            $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(2).append(emptyElement);
                        }
                    };
                });
            }
        }
    } else if ($('.my_card').eq(2).attr('class').indexOf('active') > -1) {
        if ($('.chatContent.active .itemDiv').length < 20) {
            alert(1)
            $('.load_more').remove(); return;
        } else {
            if ($('.favorites_select_zoon .style_card').eq(0).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax('/api/getOtherCollectLists', {
                    "pageNum": page_num.favorites,
                    nsfw: nsfw
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        if (res.data.length >= 1) {
                            // if(res.robot_type==0||res.isdel==1){
                            // page.favorites_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.favorites_num++;
                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_4" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                        <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                            onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                            data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                            ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                    <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                    <p class="creator">by <span id="profile${response.roleid}_4" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                        <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                                        </p>
                                        <div class="flex-col-between">
                                            ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                <ul class="tagsBox">
                                                    ${JSON.parse(response.tagsid).map((item, key) => `
                                                        <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                            ${item.name}
                                                        </li>
                                                    `).join('')}
                                                </ul>
                                            ` : '<div class="tagsBox"></div>'}
                                            <div class="bottom cen flex_box"> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                    <span>${_like_num}</span>
                                                </div> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                    <span>${_chats_num}</span>
                                                </div> 
                                                ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                            </div>
                                        </div>
                                    </a>
                                    </div>`)
                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_4`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $(`#robot${response.roleid}_4 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $(`#robot${response.roleid}_4 img`).attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`#profile${response.roleid}_4`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl($(this).attr('action-href'));
                                });
                                $(`#robot${response.roleid}_4`).on('click', function (e) {
                                    e.preventDefault();
                                    localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                    redirectToUrl(`/chat/${response.roleid}`)
                                });
                                $(`.other_options${response.roleid}_4`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_4 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_4 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_4 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                                if ($(`#robot${response.roleid}_4 .profile_card`).length > 0) {
                                    $(`#robot${response.roleid}_4 .profile_card`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                            if (res.code == 200) {
                                                $('.profileMetalMask').addClass('active');
                                                $('.profileMetal').addClass('active');
                                                $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                $('.profile_metal_list').empty();
                                                $('.profileMetalInfo').remove();
                                                res.data.forEach(item => {
                                                    $('.profile_metal_list').append(`
                                                <div class="profile_metal_item" attr-id="${item.id}">
                                                    <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                    <p class="title metal_title">${item.title}</p>
                                                </div>
                                                `);
                                                    $('.profile_metal_container').after(`
                                                <p class="profileMetalInfo">${item.desc}</p>
                                                `);
                                                });
                                                $('.profile_metal_item').eq(0).addClass('active');
                                                $('.profileMetalInfo').eq(0).addClass('active');
                                                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                    $('#profileMetalBtn').hide();
                                                }
                                            } else {
                                                error(i18n[lang].public_Failed_Show_Achievements)
                                            }
                                        });
                                    });
                                }
                            });
                            // }
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                    
                            // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                        }
                        addLoad();
                        setTimeout(() => {
                            page.favorites++;
                            isLoading = false;
                            // if(res.data.length>1&&page.favorites_total>page.favorites_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else if (res.code == 2304) {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                    } else {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                        // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                    }
                });
            } else if ($('.favorites_select_zoon .style_card').eq(1).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                     //收藏story翻页渲染
            getAjax(_url.getStoryCollectList, {
                "type": 2,
                "order": filtrate,
                "pageNum": page_num.storys,
            }).then(res => {
                $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                if (res.code == 200) {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                    $('.style_card').on('click', function () {
                        $(this).addClass('active').siblings().removeClass('active');
                    });
                    if (res.data.length >= 1) {
                        // page.characters_total=res.total;
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            // page.characters_num++;
                            $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                            $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if ($(this).data('anonymoustype') == 1) {
                                    console.log(response.users.openid, 'response.users.openid');
                                    error(i18n[lang].public_story_anonymous)
                                } else {
                                    redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                }
                            });

                        });
                    } else {
                      
                    }
                    addLoad();
                    setTimeout(() => {
                        // story_list_page.characters++;
                        isLoading = false;
                        // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                        if (res.data.length > 1) { shawdow_mask = false };
                        $('.chatContent #loadBox').hide();
                        // $('#searchInput').val('');
                        bindScroll();
                    }, 1500)
                } else {
                    const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                    // if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                    //     $('.favorites-content .innerContent').eq(1).append(emptyElement);
                    // }
                }
                isRequestInProgressStory = false;
            })
            }
        }
    } else if ($('.my_card').eq(3).attr('class').indexOf('active') > -1) {
        if ($('.chatContent.active .itemDiv').length < 20) {

            $('.load_more').remove(); return;
        } else {
            if ($('.likes_zoon .style_card').eq(0).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax('/api/getOtherLikesLists', {
                    "pageNum": page_num.likes,
                    nsfw: nsfw
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        if (res.data.length >= 1) {
                            // if(res.robot_type==0||res.isdel==1){
                            // page.likes_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.likes_num++;
                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_5" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                        <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                            onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                            data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                            ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                    <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                    <p class="creator">by <span id="profile${response.roleid}_5" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                        <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                        title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                                        </p>
                                        <div class="flex-col-between">
                                            ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                <ul class="tagsBox">
                                                    ${JSON.parse(response.tagsid).map((item, key) => `
                                                        <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                            ${item.name}
                                                        </li>
                                                    `).join('')}
                                                </ul>
                                            ` : '<div class="tagsBox"></div>'}
                                            <div class="bottom cen flex_box"> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                    <span>${_like_num}</span>
                                                </div> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                    <span>${_chats_num}</span>
                                                </div> 
                                                ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                            </div>
                                        </div>
                                    </a>
                                    </div>`)
                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_5`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $(`#robot${response.roleid}_5 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $(`#robot${response.roleid}_5 img`).attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`#profile${response.roleid}_5`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl($(this).attr('action-href'));
                                });
                                $(`#robot${response.roleid}_5`).on('click', function (e) {
                                    e.preventDefault();
                                    localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                    redirectToUrl(`/chat/${response.roleid}`)
                                });
                                $(`.other_options${response.roleid}_5`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_5 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_5 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_5 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                                if ($(`#robot${response.roleid}_5 .profile_card`).length > 0) {
                                    $(`#robot${response.roleid}_5 .profile_card`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                            if (res.code == 200) {
                                                $('.profileMetalMask').addClass('active');
                                                $('.profileMetal').addClass('active');
                                                $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                $('.profile_metal_list').empty();
                                                $('.profileMetalInfo').remove();
                                                res.data.forEach(item => {
                                                    $('.profile_metal_list').append(`
                                                <div class="profile_metal_item" attr-id="${item.id}">
                                                    <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                    <p class="title metal_title">${item.title}</p>
                                                </div>
                                                `);
                                                    $('.profile_metal_container').after(`
                                                <p class="profileMetalInfo">${item.desc}</p>
                                                `);
                                                });
                                                $('.profile_metal_item').eq(0).addClass('active');
                                                $('.profileMetalInfo').eq(0).addClass('active');
                                                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                    $('#profileMetalBtn').hide();
                                                }
                                            } else {
                                                error(i18n[lang].public_Failed_Show_Achievements)
                                            }
                                        });
                                    });
                                }
                            });
                            // }
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                            // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                        }
                        addLoad();
                        setTimeout(() => {
                            page.likes++;
                            isLoading = false;
                            // if(res.data.length>1&&page.likes_total>page.likes_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else if (res.code == 2304) {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                    } else {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                    }
                })
            } else if ($('.likes_zoon .style_card').eq(1).attr('class').indexOf('active') > -1) {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                     //收藏story翻页渲染
            getAjax(_url.likeStoryList, {
                "type": 2,
                "order": filtrate,
                "page": page_num.storys,
            }).then(res => {
                $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                if (res.code == 200) {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                    $('.style_card').on('click', function () {
                        $(this).addClass('active').siblings().removeClass('active');
                    });
                    if (res.data.length >= 1) {
                        // page.characters_total=res.total;
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            // page.characters_num++;
                            $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                            $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if ($(this).data('anonymoustype') == 1) {
                                    console.log(response.users.openid, 'response.users.openid');
                                    error(i18n[lang].public_story_anonymous)
                                } else {
                                    redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                }
                            });

                        });
                    } else {
                      
                    }
                    addLoad();
                    setTimeout(() => {
                        // story_list_page.characters++;
                        page_num.storys++;
                        isLoading = false;
                        // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                        if (res.data.length > 1) { shawdow_mask = false };
                        $('.chatContent #loadBox').hide();
                        // $('#searchInput').val('');
                        bindScroll();
                    }, 1500)
                } else {
                    const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                    // if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                    //     $('.favorites-content .innerContent').eq(1).append(emptyElement);
                    // }
                }
                isRequestInProgressStory = false;
            })
            }
        }
    }
};
var followStatus = followingStatus = true;
var _openid = 0;
var followPage = 1;
var followingPage = 1;
var isFollowLoading = isFollowingLoading = true;
var followType = 0;
$(document).ready(function () {
    if (cookie.getcookie('userInfoData') && JSON.parse(cookie.getcookie('userInfoData')).ga_status == 1) {
        updatePayMoneyGA()
    }
    var lisTening_login = null;
    clearInterval(lisTening_login);
    setTimeout(function () {
        lisTening_login = setInterval(function () {
            if (!window.isLoggedIn) {
                clearInterval(lisTening_login);
                window.location.href = host + lang=='en'?'':lang;
                return;
            }
        }, 1000);
    }, 5000);
    $('.logo').on('click', function () {
        redirectToUrl(`${lang_path}/`)
    })
    if ($('#loadBox').length === 0) {
        $('.layout-content').append($('<div id="loadBox" style="display: none;position: absolute; inset: 0; z-index: 10;background: #ffffff;"><div class="loadanimation" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);z-index: 100;"></div></div>'))
    }
    $('.layout-content #loadBox').show();
    getAjax('/api/account/profile', { e_id: eId }).then(response => {
        if (response.code == 0) {
            personal = response.data;
        } else if (response.error == 20005) {
            _error(i18n[lang].error_20005);
        } else if (response.error == 20902) {
            _error(i18n[lang].error_20902);
        }
    });
    $('.character-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.character-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('.chat-story-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.chat-story-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('.likes-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.likes-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('.favorites-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.favorites-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('#personal_metal_info').on('click', function () {
        _getAjax(_url.titleList, { uid: JSON.parse(cookie.getcookie('userInfoData')).uid ,lang:lang}).then(res => {
            if (res.code == 200) {
                $('.profileMetalMask').addClass('active');
                $('.profileMetal').addClass('active');
                $('.profileMetal h2').html(JSON.parse(cookie.getcookie('userInfoData')).nickname + i18n[lang].public_Achievement);
                $('.profile_metal_list').empty();
                $('.profileMetalInfo').remove();
                res.data.forEach(item => {
                    $('.profile_metal_list').append(`
                    <div class="profile_metal_item" attr-id="${item.id}">
                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                        <p class="title metal_title">${item.title}</p>
                    </div>
                    `);
                    $('.profile_metal_container').after(`
                    <p class="profileMetalInfo">${item.desc}</p>
                    `);
                });
                $('.profile_metal_item').eq(0).addClass('active');
                $('.profileMetalInfo').eq(0).addClass('active');
                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id')).hide();
            } else {
                error(i18n[lang].public_Failed_Show_Achievements)
            }
        });
    });
    function followLoadMore() {
        if (isFollowLoading || isFollowLoading) return;
        if (followType == 0) {
            isFollowLoading = true;
            getAjax(_url.fanList, { page: followPage, limit: 10 }).then(res => {
                if (res.code == 200) {
                    if (res.data.data.length > 0) {
                        $('.followerMetalMask .info').hide();
                    };
                    res.data.data.forEach(item => {
                        $('.followerMetalMask .follower_zoon').append(`
                            <a href="${lang_path}/account/profile/${item.users2.openid}" class="follow_item flex_box" id="follow_item${item.users2.openid}">
                            <div class="flex_box author_info">
                                <img src="${item.users2.avatar_url}" loading="lazy" alt="Avatar" width="3rem" height="3rem" >
                                <span class="author_name" attr-openid="${item.users2.openid}" id="author_name${item.users2.openid}">${item.users2.nickname}</span>
                            </div>
                            <span class="follow_btn ${item.is_followed == true || item.is_followed == 'true' ? 'following' : 'follow'}" attr-follow="${item.is_followed == true || item.is_followed == 'true' ? 1 : 0}">${item.is_followed == true || item.is_followed == 'true' ? i18n[lang].public_Following : i18n[lang].public_Follow}</span>
                            </a>
                        `);
                        if ($(window).width() > 1200) {
                            $(`.followerMetalMask #follow_item${item.users2.openid} .follow_btn`).hover(function () {
                                if ($(this).attr('class').indexOf('following') > -1) {
                                    $(this).text(i18n[lang].public_Unfollow)
                                }
                            }, function () {
                                if ($(this).attr('class').indexOf('following') > -1) {
                                    $(this).text(i18n[lang].public_Following);
                                }
                            });
                        };
                        $(`.followerMetalMask #follow_item${item.users2.openid} .follow_btn`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            _openid = item.users2.openid;
                            if ($(this).attr('attr-follow') == 1) {
                                _status = 0;
                                $('.confirmFollowMask').addClass('active');
                                $('.confirmFollowMask h2 span').text(`${item.users2.nickname}`);
                                $('.confirmFollowMask').addClass('active');
                                $('.confirmFollowMask .confirm_btn').attr('attr-openid', item.users2.openid);
                            } else {
                                _status = 1;
                                updateFollowStatus(_openid, _status);
                            }
                        });
                    });
                    setTimeout(() => {
                        followPage++;
                        if (followPage >= res.data.last_page) {
                            follow_unbindScroll();
                            isFollowLoading = true;
                        } else {
                            isFollowLoading = false;
                            follow_bindScroll();
                        };
                    }, 500);
                } else if (res.error == 20005) {
                } else if (res.error == 20902) {
                } else {

                }
            });
        } else {
            isFollowingLoading = true;
            getAjax(_url.followList, { page: followingPage, limit: 10 }).then(res => {
                if (res.code == 200) {
                    if (res.data.data.length > 0) {
                        $('.followingMetalMask .info').hide();
                    };
                    res.data.data.forEach(item => {
                        $('.followingMetalMask .follower_zoon').append(`
                            <a href="${lang_path}/account/profile/${item.users.openid}" class="follow_item flex_box" id="follow_item${item.users.openid}">
                            <div class="flex_box author_info">
                                <img src="${item.users.avatar_url}" loading="lazy" alt="Avatar" width="3rem" height="3rem" >
                                <span class="author_name" attr-openid="${item.users.openid}" id="author_name${item.users.openid}">${item.users.nickname}</span>
                            </div>
                            <span class="follow_btn ${item.status == 1 ? 'following' : 'follow'}" attr-follow="">${item.status == 1 ? i18n[lang].public_Following : i18n[lang].public_Follow}</span>
                            </a>
                        `);
                        if ($(window).width() > 1200) {
                            $(`.followingMetalMask #follow_item${item.users.openid} .follow_btn`).hover(function () {
                                if ($(this).attr('class').indexOf('following') > -1) {
                                    $(this).text(i18n[lang].public_Unfollow)
                                }
                            }, function () {
                                if ($(this).attr('class').indexOf('following') > -1) {
                                    $(this).text(i18n[lang].public_Following);
                                }
                            });
                        };
                        $(`.followingMetalMask #follow_item${item.users.openid} .follow_btn`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            _openid = item.users.openid;
                            _status = 0;
                            $('.confirmFollowMask').addClass('active');
                            $('.confirmFollowMask h2 span').text(`${item.users.nickname}`);
                            $('.confirmFollowMask').addClass('active');
                            $('.confirmFollowMask .confirm_btn').attr('attr-openid', item.users.openid);
                        });
                    });
                    setTimeout(() => {
                        followingPage++;
                        if (followingPage >= res.data.last_page) {
                            follow_unbindScroll();
                            isFollowingLoading = true;
                        } else {
                            isFollowingLoading = false;
                            follow_bindScroll();
                        };
                    }, 500);
                } else if (res.error == 20005) {
                } else if (res.error == 20902) {
                } else {

                }
            });
        };
    };
    // 解除绑定 scroll 事件
    function follow_unbindScroll() {
        $('.follower_zoon').off('scroll', follow_handleScroll);
    }

    // 重新绑定 scroll 事件
    function follow_bindScroll() {
        $('.follower_zoon').on('scroll', follow_handleScroll);
    }

    // 定义 scroll 事件处理函数
    function follow_handleScroll() {
        const scrollTop = $(this).scrollTop();
        const scrollHeight = $(this).prop('scrollHeight');
        const clientHeight = $(this).height();
        if (scrollTop + clientHeight >= scrollHeight - 200) {
            followLoadMore();
        }
    }
    follow_bindScroll();
    function getFollowing() {
        followingPage = 1;
        $('.followingMetalMask .info').hide();
        getAjax(_url.followList, { page: followingPage, limit: 10 }).then(res => {
            if (res.code == 200) {
                if (res.data.data.length > 0) {
                    $('.followingMetalMask .follow_item').remove();
                };
                res.data.data.forEach(item => {
                    $('.followingMetalMask .follower_zoon').append(`
                        <a href="${lang_path}/account/profile/${item.users.openid}" class="follow_item flex_box" id="follow_item${item.users.openid}">
                        <div class="flex_box author_info">
                            <img src="${item.users.avatar_url}" loading="lazy" alt="Avatar" width="3rem" height="3rem" >
                            <span class="author_name" attr-openid="${item.users.openid}" id="author_name${item.users.openid}">${item.users.nickname}</span>
                        </div>
                        <span class="follow_btn ${item.status == 1 ? 'following' : 'follow'}" attr-follow="">${item.status == 1 ? i18n[lang].public_Following : i18n[lang].public_Follow}</span>
                        </a>
                    `);
                    if ($(window).width() > 1200) {
                        $(`.followingMetalMask #follow_item${item.users.openid} .follow_btn`).hover(function () {
                            if ($(this).attr('class').indexOf('following') > -1) {
                                $(this).text(i18n[lang].public_Unfollow)
                            }
                        }, function () {
                            if ($(this).attr('class').indexOf('following') > -1) {
                                $(this).text(i18n[lang].public_Following);
                            }
                        });
                    };
                    $(`.followingMetalMask #follow_item${item.users.openid} .follow_btn`).on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        _openid = item.users.openid;
                        _status = 0;
                        $('.confirmFollowMask').addClass('active');
                        $('.confirmFollowMask h2 span').text(`${item.users.nickname}`);
                        $('.confirmFollowMask').addClass('active');
                        $('.confirmFollowMask .confirm_btn').attr('attr-openid', item.users.openid);
                    });
                });
                setTimeout(() => {
                    followingPage++;
                    if (followingPage >= res.data.last_page) {
                        follow_unbindScroll();
                        isFollowingLoading = true;
                    } else {
                        isFollowingLoading = false;
                        follow_bindScroll();
                    };
                }, 500);
            } else if (res.error == 20005) {
                $('.followingMetalMask .info').show();
            } else if (res.error == 20902) {
                $('.followingMetalMask .info').show();
            } else {
                $('.followingMetalMask .info').show();
            }
        }).catch(error => { $('.followingMetalMask .info').show(); })
    };
    function getFolloed() {
        followPage = 1;
        $('.followerMetalMask .info').hide();
        getAjax(_url.fanList, { page: followPage, limit: 10 }).then(res => {
            if (res.code == 200) {
                if (res.data.data.length > 0) {
                    $('.followerMetalMask .follow_item').remove();
                };
                res.data.data.forEach(item => {
                    $('.followerMetalMask .follower_zoon').append(`
                        <a href="${lang_path}/account/profile/${item.users2.openid}" class="follow_item flex_box" id="follow_item${item.users2.openid}">
                        <div class="flex_box author_info">
                            <img src="${item.users2.avatar_url}" loading="lazy" alt="Avatar" width="3rem" height="3rem" >
                            <span class="author_name" attr-openid="${item.users2.openid}" id="author_name${item.users2.openid}">${item.users2.nickname}</span>
                        </div>
                        <span class="follow_btn ${item.is_followed == true || item.is_followed == 'true' ? 'following' : 'follow'}" attr-follow="${item.is_followed == true || item.is_followed == 'true' ? 1 : 0}">${item.is_followed == true || item.is_followed == 'true' ? i18n[lang].public_Following : i18n[lang].public_Follow}</span>
                        </a>
                    `);
                    if ($(window).width() > 1200) {
                        $(`.followerMetalMask #follow_item${item.users2.openid} .follow_btn`).hover(function () {
                            if ($(this).attr('class').indexOf('following') > -1) {
                                $(this).text(i18n[lang].public_Unfollow)
                            }
                        }, function () {
                            if ($(this).attr('class').indexOf('following') > -1) {
                                $(this).text(i18n[lang].public_Following);
                            }
                        });
                    };
                    $(`.followerMetalMask #follow_item${item.users2.openid} .follow_btn`).on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        _openid = item.users2.openid;
                        if ($(this).attr('attr-follow') == 1) {
                            _status = 0;
                            $('.confirmFollowMask').addClass('active');
                            $('.confirmFollowMask h2 span').text(`${item.users2.nickname}`);
                            $('.confirmFollowMask').addClass('active');
                            $('.confirmFollowMask .confirm_btn').attr('attr-openid', item.users2.openid);
                        } else {
                            _status = 1;
                            updateFollowStatus(_openid, _status);
                        }
                    });
                });
                setTimeout(() => {
                    followPage++;
                    if (followPage >= res.data.last_page) {
                        follow_unbindScroll();
                        isFollowLoading = true;
                    } else {
                        isFollowLoading = false;
                        follow_bindScroll();
                    };
                }, 500);
            } else if (res.error == 20005) {
                $('.followerMetalMask .info').show();
            } else if (res.error == 20902) {
                $('.followerMetalMask .info').show();
            } else {
                $('.followerMetalMask .info').show();
            }
        }).catch(error => { $('.followerMetalMask .info').show(); })
    };
    // show follow list
    function updateFollowStatus(openid, status) {
        // 消息关注
        getAjax(_url.followUpdate, {
            "uid": openid,
            "status": status
        }).then(res => {
            if (res.code == 200) {
                if (status == 0) {
                    $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Follow).addClass('follow').removeClass('following').attr('attr-follow', 0);
                    if (followType == 1) { $(`.followingMetalMask #follow_item${openid}`).remove(); }
                    success(i18n[lang].public_Successfully_Unfollow);
                    $(`.followingMetalMask .follow_item`).length ? null : $('.followingMetalMask .info').show();
                    $('.confirmFollowMask').removeClass('active');
                    $('.followingMetalMask #follow_item' + openid).hide();
                    resetInfo();
                } else {
                    $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Following).removeClass('follow').addClass('following').attr('attr-follow', 1);
                    success(i18n[lang].public_Successfully_Follow);

                    resetInfo();
                }
            } else {
                if (status == 0) {
                    $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Following).removeClass('follow').addClass('following').attr('attr-follow', 1);
                    error(i18n[lang].public_Failed_Unlike);
                } else {
                    $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Follow).addClass('follow').removeClass('following').attr('attr-follow', 0);
                    error(i18n[lang].public_Failed_Followed);
                }
            }
        }).catch(err => {
            if (status == 0) {
                $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Following).removeClass('follow').addClass('following').attr('attr-follow', 1);
                error(i18n[lang].public_Failed_Unlike);
            } else {
                $(`${followType == 1 ? '.followingMetalMask' : '.followerMetalMask'} #follow_item${openid} .follow_btn`).html(i18n[lang].public_Follow).addClass('follow').removeClass('following').attr('attr-follow', 0);
                error(i18n[lang].public_Failed_Followed);
            }
        });
    };
    $('.confirmFollowMask .confirm_btn').on('click', function (e) {
        _openid = $('.confirm_btn').attr('attr-openid');
        updateFollowStatus(_openid, 0);
    });
    $('.confirmFollowMask .cancel_btn,.confirmFollowMask .close').on('click', function (e) {
        $('.confirmFollowMask').removeClass('active');
    });
    // 关闭 follow 弹窗
    $('.followerMetalMask .close').on('click', function () {
        $('.followerMetalMask').removeClass('active');
    });
    $('.followingMetalMask .close').on('click', function () {
        $('.followingMetalMask').removeClass('active');
    });
    $('#follower_btn').on('click', function () {
        $('.followerMetalMask').addClass('active');
        followType = 0;
        getFolloed()
    });
    $('#following_btn').on('click', function () {
        $('.followingMetalMask').addClass('active');
        followType = 1;
        getFollowing();
    });
});


$(document).on('click', '.profileMetal .profile_metal_item', function (e) {
    e.stopPropagation();
    $(this).addClass('active').siblings().removeClass('active');
    $('.profileMetal .profileMetalInfo').eq($(this).index()).addClass('active').siblings('.profileMetal .profileMetalInfo').removeClass('active');
    $('#profileMetalBtn').attr('attr-id', $(this).attr('attr-id'))
});
$(document).on('click', '.profileMetalMask .close', function (e) {
    e.stopPropagation();
    $('.profileMetalMask').removeClass('active');
    $('.profileMetal').removeClass('active');
});
$(document).on('click', '#profileMetalBtn', function (e) {
    e.stopPropagation(); checkLoginStatus(); // 每次点击按钮时先检查登录状态
    if (!window.isLoggedIn) {
        location.href = `${lang_path}/account/login/`
    } else {
        location.href = `${lang_path}/bonus/?#metal_zoon`+ $(this).attr('attr-id');
        
    }
});
function setStatus() {
    for (var ok = 0; ok < $('.homeItemInPHP .default-avatar').length; ok++) {
        var oAbc = $('.homeItemInPHP .default-avatar').eq(ok)[0].getBoundingClientRect();
        $('.homeItemInPHP .default-avatar').eq(ok).attr({ 'width': oAbc.width, 'height': oAbc.height })
    }
};
setStatus();
$(window).resize(function () {
    setStatus()
});

$('.copy_btn').on('click', function () {
    copyToClipboard($('#share_link').html());
    $(this).addClass('active');
    $(this).parent().siblings('.share_error').addClass('active');
});


$(document).on('click', function (e) {
    $('.other_options').find('i').removeClass('active');
    $('.other_options').find('a').removeClass('active');
    $('.other_options').find('span').removeClass('active');
});


if (getQueryVariable('sub_id')) {
    setTimeout(async () => {
        await checkoutChargee(getQueryVariable('sub_id'))
    }, 2000)
} else {
    updateUserPlan();
}
//个人plan 展示
$('.main_right .icon_question').on('click', function () {
    $('.message_details').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
    $('.ivu-layout-content').addClass('hide_pro');
    if ($(this).hasClass('unlock_question')) {
        manage('IUnlock_Person_Describe_Click');
    } else {
        manage('Profile_Plan_Click', '');
    }
});
//分享
$('.profile_share').on('click', function () {
    $('.share_box').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
    $('.ivu-layout-content').addClass('hide_pro');

    manage('Profile_Share_Click', '')
});
//设置
$('.profile_settings').on('click', function () {
    $('.settings_box').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
    $('.ivu-layout-content').addClass('hide_pro');

    manage('Profile_Setting_Click', '')
});
//弹窗逻辑
$('.profile_close').on('click', function () {
    $(this).parent().removeClass('active');
    $('.profile_mask').removeClass('active');
    $('body').removeClass('hide_pro');
    $('.ivu-layout-content').removeClass('hide_pro');
    $('.getcode').html('Get').removeClass('nobind');
    $('.input_box p').html('');
    $('.clause_delete .check').removeClass('active');
    $('.clause_delete .check').siblings('.delete_zoon').find('.delete_btn').addClass('fit');
    $('delete_now').removeClass('active').html('Delete Now');
});
$('.cancel_btn').on('click', function () {
    $('.delete_info').removeClass('active');
    $('.profile_mask').removeClass('active');
    $('body').removeClass('hide_pro');
    $('.ivu-layout-content').removeClass('hide_pro');
    $('.clause_delete .check').removeClass('active');
    $('.clause_delete .check').siblings('.delete_zoon').find('.delete_btn').addClass('fit');
    $('delete_now').removeClass('active').html('Delete Now');
});
$('.clause_delete .delete_btn').on('click', function () {
    if ($(this).attr('class').indexOf('fit') == -1) {
        $('.clause_delete').removeClass('active').siblings('.confirm_delete').addClass('active');
    } else {
        success(i18n[lang].public_showToast_9)
    }
});
$('.confirm_delete .delete_btn').on('click', function () {
    $('.confirm_delete').removeClass('active').siblings('.password_less').addClass('active');
});
$('.profile_btn').on('click', function () {
    $('.settings_box').removeClass('active');
    if ($(this).attr('class').indexOf('about_account') > -1) {
        $('.account_info').addClass('active');
    } else if ($(this).attr('class').indexOf('about_security') > -1) {
        $('.getcode').html('Get').removeClass('nobind');
        $('.input_box p').html('');
        if (personal.has_password) {
            $('.change_password').addClass('active');
        } else {
            $('.add_password').addClass('active');
        }
    } else if ($(this).attr('class').indexOf('delete_account') > -1) {
        $('.clause_delete').addClass('active');
        $('.getcode').html('Get').removeClass('nobind');
        $('.input_box p').html('');
    }
});
//more_introduction
$('.more_introduction').on('click', function () {
    $(this).toggleClass('active');
    $('.profile_introduction').toggleClass('active');
});
$('.character-content  .genderAllTransparentMask,.chat-story-content  .genderAllTransparentMask').on('click', function (e) {
    e.stopPropagation();
    $('.character-content .genderAllTransparentMask').removeClass('active').hide();
    $('.character-content .genderAll').removeClass('active');
    $('.chat-story-content .genderAllTransparentMask').removeClass('active').hide();
    $('.chat-story-content .genderAll').removeClass('active');
    $('html').removeClass('hide');
});

if ($('.character-content  .genderAllTransparentMask .recentListContent .item').length > 0) {
    $('.character-content  .genderAllTransparentMask .recentListContent .item').each((i, el) => {
        $(el).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (_isRequestInProgress) {
                warning(i18n[lang].pricing_character_finish_loading)
                return
            };
            _first_check = true;
            e.stopPropagation();
            switch ($(this).index()) {
                case 0:
                    filtrate = 3;
                    manage('Profile_Latest_Click', '');
                    break;
                case 1:
                    filtrate = 1;
                    manage('Profile_Popular_Click', '');
                    break;
            };
            for (var i = 0; i < $('.character-content .style_card').length; i++) {
                if ($('.character-content .style_card').eq(i).attr('class').indexOf('active') > -1) {
                    my_card_index = i;
                }
            }
            if (my_card_index == 1) {
                robot_type = 0
            } else if (my_card_index == 2) {
                robot_type = 1
            }

            console.log(2314, filtrate, robot_type, my_card_index, nsfw);
            var profile_filtrate = {
                filtrate: filtrate,
                openid: JSON.parse(cookie.getcookie('userInfoData')).openid,
            }
            cookie.setcookie('profile_filtrate', JSON.stringify(profile_filtrate));
            $('.character-content .classification .genderAll i').eq(0).html($(el).text());
            console.log($(el).text());
            $('.character-content .genderAllTransparentMask').removeClass('active').hide();
            _first_check = true;
            add_type_lists(filtrate, robot_type, my_card_index, 1);
            $('html').removeClass('hide');
        })
    });
    $('.recentListContent').on('draggable', function () {
        return false;
    })
};
//故事下拉框展开
$('.chat-story-content .genderAll').click(function () {
    var $genderAll = $('.chat-story-content #showGender');
    if ($genderAll.css('display') === 'none') {
        $genderAll.show();
        if ($(window).width() > 650) {
            $('.chat-story-content .recentListContent').css({
                'top': $('.chat-story-content .classification .genderAll').offset().top + 55 - $(window).scrollTop(),
                'left': $('.chat-story-content .classification .genderAll').offset().left - 8
            });
        } else {
            $('.chat-story-content .recentListContent').css({
                'top': $('.chat-story-content .classification .genderAll').offset().top + 35 - $(window).scrollTop(),
                'left': $('.chat-story-content .classification .genderAll').offset().left - 8
            });
        }
        $('.chat-story-content .genderAllTransparentMask').addClass('active');
        $(this).addClass('active');
        $('html').addClass('hide');
    }
})
if ($('.chat-story-content  .genderAllTransparentMask .recentListContent .item').length > 0) {
    $('.chat-story-content  .genderAllTransparentMask .recentListContent .item').each((i, el) => {
        $(el).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (_isRequestInProgress) {
                warning(i18n[lang].pricing_character_finish_loading)
                return
            };
            _first_check = true;
            e.stopPropagation();
            switch ($(this).index()) {
                case 0:
                    filtrate = 3;
                    manage('Profile_Latest_Click', '');
                    break;
                case 1:
                    filtrate = 1;
                    manage('Profile_Popular_Click', '');
                    break;
            };
            for (var i = 0; i < $('.chat-story-content .style_card').length; i++) {
                if ($('.chat-story-content .style_card').eq(i).attr('class').indexOf('active') > -1) {
                    my_card_index = i;
                }
            }
            if (my_card_index == 0) {
                robot_type = 1
            } else if (my_card_index == 1) {
                robot_type = 2
            } else if (my_card_index == 2) {
                robot_type = 3
            }

            console.log(2314, filtrate, robot_type, my_card_index, nsfw);
            var profile_filtrate = {
                filtrate: filtrate,
                openid: JSON.parse(cookie.getcookie('userInfoData')).openid,
            }
            cookie.setcookie('profile_filtrate', JSON.stringify(profile_filtrate));
            $('.chat-story-content .classification .genderAll i').eq(0).html($(el).text());
            console.log($(el).text());
            $('.chat-story-content .genderAllTransparentMask').removeClass('active').hide();
            _first_check = true;
            add_type_story_lists(filtrate, robot_type, my_card_index, 1);
            $('html').removeClass('hide');
        })
    });
    $('.recentListContent').on('draggable', function () {
        return false;
    })
};
function add_type_story_lists(filtrate, robot_type, my_card_index, nsfw) {
    if (_isRequestInProgress) {
        return;
    };
    _isRequestInProgress = true;
    if (_first_check) {
        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(my_card_index).empty();
        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(my_card_index).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        var per_page = 0;
        if (my_card_index == 0) {
            page_num.characters = 1;
            per_page = page_num.characters;
            page_num.characters_num = 0;
        } else if (my_card_index == 1) {
            page_num.public = 1;
            per_page = page_num.public;
            page_num.public_num = 0;
        } else if (my_card_index == 2) {
            page_num.private = 1;
            per_page = page_num.private;
            page_num.private_num = 0;
        }
        page_num.storys = 1
        //故事右侧类型切换盒子渲染
        getAjax(_url.personStoryList, {
            "type": robot_type,
            "order": filtrate,
            "page": 1,
        }).then(res => {
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(my_card_index).find('.load_more').remove();
                if (my_card_index == 0) {
                    page_num.characters_total = res.total;
                } else if (my_card_index == 1) {
                    page_num.public_total = res.total;
                } else if (my_card_index == 2) {
                    page_num.private_total = res.total;
                };
                if (res.data.length >= 1) {
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.storys_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(my_card_index).append(`
                       <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                        $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if ($(this).data('anonymoustype') == 1) {
                                console.log(response.users.openid, 'response.users.openid');
                                error(i18n[lang].public_story_anonymous)
                            } else {
                                redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                            }
                        });
                    });
                } else {
                    const emptyElement = $(`
                                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                    </div>
                                `)
                    if (!$('.chat-story-content .innerContent').eq(my_card_index).find('.show_result').length) {
                        $('.chat-story-content .innerContent').eq(my_card_index).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    if (my_card_index == 0) {
                        page_num.storys++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.storys_total > page_num.storys_num) { mask_shawdow = false };
                    } else if (my_card_index == 1) {
                        page_num.public++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.storys_public_total > page_num.storys_public_num) { mask_shawdow = false };
                    } else if (my_card_index == 2) {
                        page_num.storys_private++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.storys_private_total > page_num.storys_private_num) { mask_shawdow = false };
                    }
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)

            };
            _isRequestInProgress = false;
        }).catch(error => {
            console.error('Error fetching robot list:', error);
            _isRequestInProgress = false; // 确保在请求失败时重置标志变量
        })
        _first_check = false;
    };
};
function add_type_lists(filtrate, robot_type, my_card_index, nsfw) {
    if (_isRequestInProgress) {
        return;
    };
    _isRequestInProgress = true;
    if (_first_check) {
        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(my_card_index).empty();
        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(my_card_index).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
        var per_page = 0;
        if (my_card_index == 0) {
            page_num.characters = 1;
            per_page = page_num.characters;
            page_num.characters_num = 0;
        } else if (my_card_index == 1) {
            page_num.public = 1;
            per_page = page_num.public;
            page_num.public_num = 0;
        } else if (my_card_index == 2) {
            page_num.private = 1;
            per_page = page_num.private;
            page_num.private_num = 0;
        }
        //第一个盒子渲染
        getAjax(`/api/userRobotLists`, {
            e_id: eId,
            filtrate: filtrate,
            pageNum: per_page,
            robot_type: robot_type,
        }).then(res => {
            if (res.code == 200) {
                $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(my_card_index).find('.load_more').remove();
                if (my_card_index == 0) {
                    page_num.characters_total = res.total;
                } else if (my_card_index == 1) {
                    page_num.public_total = res.total;
                } else if (my_card_index == 2) {
                    page_num.private_total = res.total;
                };
                if (res.data.length >= 1) {
                    res.data.forEach(response => {
                        var _openid = '', _nickname = '';
                        if (response.userProfile && response.userProfile.openid) {
                            _openid = response.userProfile.openid
                        }
                        if (response.userProfile && response.userProfile.nickname) {
                            _nickname = response.userProfile.nickname
                        };
                        page_num.characters_num++;
                        var _like_num, _chats_num;
                        response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                        response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                        $('.main_right .ivu-row.chatContent').eq(0).find('.innerContent').eq(my_card_index).append(`
                        <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_${my_card_index + 1}" class="item homeItemInPHP robot${response.roleid}_${my_card_index + 1}" data-roleid="${response.roleid}">
                                <div class="character-img-box">
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar ${(response.ex_status == 0 || response.ex_status == 3) ? 'blur-status' : ''}" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.ex_status == 2 ? `<span class="character-status private"><i></i>${i18n[lang].public_Private}</span>` : response.ex_status == 3 ? `<span class="character-status restricted"><i></i>${i18n[lang].public_Restricted_Display}</span>` : response.ex_status == 0 ? `<span class="character-status"><i></i>${i18n[lang].public_Under_Review}</span>` : ''}
                                
                                            </div> 
                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_${my_card_index + 1}">${response.name}</span>
                                <p class="creator">by <span id="profile${response.roleid}_${my_card_index + 1}" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                    <div class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}" title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                        ${escapeHtml(response.describe) || ''}
                                    </div>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_${my_card_index + 1}"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_${my_card_index + 1}"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                            </div>`);
                        const image = new Image();
                        image.src = response.avatar_url
                        image.onload = function () {
                            var $img = $(`#robot${response.roleid}_${my_card_index + 1}`).find('.img');
                            if ($img.length) {
                                $img.attr('src', image.src);
                                var oAbc = $img[0].getBoundingClientRect();
                                if (oAbc.width) {
                                    $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                } else {
                                    $img.attr({ 'width': image.width, 'height': image.height });
                                }
                            } else {
                                console.error('Image element not found for roleid:', response.roleid);
                            }
                        }
                        $(`#name${response.roleid}_${my_card_index + 1}`).on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            redirectToUrl(`${lang_path}/character/${response.roleid}`);
                        });
                        $(`.other_options${response.roleid}_${my_card_index + 1}`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                $(this).find('i').removeClass('active').siblings().removeClass('active');
                            } else {
                                $(document).trigger('click');
                                $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                            }
                        });
                        $(`.other_options${response.roleid}_${my_card_index + 1} .report`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_${my_card_index + 1}`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                report_arguments(response.roleid, response.name, response.nsfw);
                            }
                        });
                        $(`.other_options${response.roleid}_${my_card_index + 1} .character_edit`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            $(this).removeClass('active');
                            $(`.other_options${response.roleid}_${my_card_index + 1}`).find('i').removeClass('active');
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                redirectToUrl($(this).attr('action-href'));
                            }
                        });
                        $(`#robot${response.roleid}_${my_card_index + 1} .icon-icon_like2`).on('click', function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var that = $(this);
                            checkLoginStatus(); // 每次点击按钮时先检查登录状态
                            if (!window.isLoggedIn) {
                                login_status()
                            } else {
                                that.toggleClass('active');
                                var _num = that.attr('like-num');
                                if (that.hasClass('active')) {
                                    create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                } else {
                                    create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                }
                            }
                        });
                    });
                } else {
                    const emptyElement = $(`
                                    <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                    </div>
                                `)
                    if (!$('.innerContent').eq(my_card_index).find('.show_result').length) {
                        $('.innerContent').eq(my_card_index).append(emptyElement);
                    }
                }
                addLoad();
                setTimeout(() => {
                    if (my_card_index == 0) {
                        page_num.characters++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.characters_total > page_num.characters_num) { mask_shawdow = false };
                    } else if (my_card_index == 1) {
                        page_num.public++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.public_total > page_num.public_num) { mask_shawdow = false };
                    } else if (my_card_index == 2) {
                        page_num.private++;
                        isLoading = false;
                        if (res.data.length > 1 && page_num.private_total > page_num.private_num) { mask_shawdow = false };
                    }
                    $('.chatContent #loadBox').hide();
                    $('#searchInput').val('');
                    addTooltip();
                    bindScroll();
                }, 1500)

            };
            _isRequestInProgress = false;
        }).catch(error => {
            console.error('Error fetching robot list:', error);
            _isRequestInProgress = false; // 确保在请求失败时重置标志变量
        })
        _first_check = false;
    };
};
//tab 切换
$('.my_card').on('click', function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('.chatContent').eq($(this).index()).addClass('active').siblings('.chatContent').removeClass('active');
    my_card_index = $(this).index();
    setStatus();
});
$('.clause_delete .check').on('click', function () {
    $(this).toggleClass('active');
    $(this).siblings('.delete_zoon').find('.delete_btn').toggleClass('fit');
});

//下面是会员相关的方法 如无必要 不要动
/********************
 * 打住 打住 打住
 * 打住 打住 打住
 * 打住 打住 打住
 * ***********************/
//member
// localStorage.setItem('lang', lang)
//邮箱正则判断
let reg_email = /^[a-zA-Z0-9.!#$%&#$%&amp; '*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let reg_password = /.{8,}$/;
let reg_code = /^[0-9]{6,6}$/;
function error_fn(id, that) {
    switch (id) {
        case 20001:
            _error(i18n[lang].error_20001);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20002:
            _error(i18n[lang].error_20002);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20003:
            _error(i18n[lang].error_20003);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20004:
            _error(i18n[lang].error_20004);
            return false;
            break;
        case 20005:
            setCookie("user", "", -1)
            if (location.origin.indexOf('account.') > -1) {
                location.href = `${lang_path}/account/login/`;
            }
            return false;
            break;
        case 20006:
            _error(i18n[lang].error_20006);
            return false;
            break;
        case 20007:
            _error(i18n[lang].error_20007);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20008:
            _error(i18n[lang].error_20008);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
        case 20009:
            _error(i18n[lang].error_20009);
            if (location.origin.indexOf('account.') > -1) {
                setTimeout(function () {
                    location.href = `${lang_path}/account/login/`;
                }, 1000);
            }
            return false;
            break;
    }
    return true;
}
// 地址栏判断操作
if (getQueryVariable('operation')) {
    sessionStorage.setItem('operation', 'close');
}
if (getQueryVariable('3rdGoogle') == 'error') {
    _error(i18n[lang].error_22298);
}
$.ajaxSetup({
    headers: {
        'basic-params': ''
    }
});
// // 添加.html
// for(var i=0;i<$('a').length;i++){
//     if(String($('a').eq(i).attr('href')).indexOf('.html')<0){
//         var url=$('a').eq(i).attr('href')+'.html';
//         $('a').eq(i).attr('href',url);
//     }
// };
function setCookie(name, value, iDay) {
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    var currentDomain = '.' + document.domain;

    // 如果当前域名是顶级域名(如 .heyreal.ai)，则不需要添加前缀'.'
    if (currentDomain === '.' + document.domain.split('.').slice(-2).join('.')) {
        currentDomain = document.domain;
    }

    document.cookie = name + '=' + value + ';path=/;domain=' + currentDomain + ';expires=' + oDate;
}
//记住页面来源
if (getQueryVariable('source')) {
    localStorage.setItem('source', getQueryVariable('source'));
} else {
    if (!localStorage.getItem('source')) {
        localStorage.setItem('source', websiet);
    }
}
// input框的事件
var input_placeholder;
$('.member input').focus(function () {
    input_placeholder = $(this).attr('placeholder');
    $(this).attr('placeholder', '');
    $(this).parent().find('p').html('');
})
$('.member input').blur(function () {
    $(this).attr('placeholder', input_placeholder);
});
// email框
$('.member input.email').blur(function () {
    let value = $(this).val().replace(/(^\s*)|(\s*$)/g, "");
    $(this).val(value);
    if (!$(this).val()) {
        //判断是否邮箱为空
        $(this).addClass('active');
        $(this).next().html(i18n[lang].email_not_valid_1);
        return false;
    } else if (!reg_email.test($(this).val())) {
        //正则判断格式是否正确
        $(this).addClass('active');
        $(this).next().html(i18n[lang].email_not_valid);
        return false;
    } else { }
});
$('.member input.email').focus(function () {
    $(this).removeClass('active');
    let value = $(this).val().replace(/(^\s*)|(\s*$)/g, "");
    $(this).val(value);
});
// code
$('.member input.code').blur(function () {
    if ($(this).attr('readonly')) {
        return false;
    } else {
        if (!$(this).val()) {
            $(this).addClass('active');
            $(this).next().next().html(i18n[lang].code_empty);
        } else if (!reg_code.test($(this).val())) {
            $(this).addClass('active');
            $(this).next().next().html(i18n[lang].code_not_valid);
        } else {

        }
    }
});
$('.member input.code').focus(function () {
    $(this).removeClass('active');
    if ($(this).attr('readonly')) {
        $(this).attr('placeholder', input_placeholder);
        $(this).next().next().html(i18n[lang].get_first_code);
    }
});
// password
$('.member input.password').blur(function () {
    if ($(this).parents('.login').length > 0) {
        return false;
    }
    if (!$(this).val()) {
        $(this).addClass('active');
        $(this).next().html(i18n[lang].password_empty);
        return false;
    } else if (!reg_password.test($(this).val())) {
        $(this).addClass('active');
        $(this).next().html(i18n[lang].password_not_valid_1 + '.');
        return false;
    } else { }
});
$('.member input.copy_password').blur(function () {
    if (!$(this).val()) {
        $(this).addClass('active');
        $(this).next().html(i18n[lang].copy_password_empty);
        return false;
    }
});
$('.member input.password').focus(function () {
    $(this).removeClass('active');
});
//显示隐藏密码
$('.password_box').find('div').click(function (e) {
    e.stopPropagation();
    $(this).parent().toggleClass('active');
    var input = $(this).parent().find('input');
    if ($(this).parent().attr('class').indexOf('active') > -1) {
        input[0].type = "text";
    } else {
        input[0].type = "password";
    }
})
//查看提示文字是多少行
// $('.delet_accout .member .input_box>p').on('DOMNodeInserted',function(){
//     console.log('计算高度',$(this).height())
//     var num=Math.round($(this).height()/parseFloat($(this).css('line-height')))
//     if(num>1){
//         $(this).parent().find('input').css({
//             'marginBottom':22*num+6
//         })
//     }
// });
var timeClock;
//获取注册码
function sendCode(element, state) {
    if (!state) {
        element.html(i18n[lang].Get).removeClass('nobind');
        clearInterval(timeClock);
        return false;
    }
    element.html('60s');
    var timer_num = 60;
    timeClock = setInterval(function () {
        timer_num--;
        element.html(timer_num + 's');

        if (timer_num <= 0) {
            element.html(i18n[lang].Get).removeClass('nobind');
            element.next().html(i18n[lang].not_received_code);
            clearInterval(timeClock);
        }
    }, 1000);
};
//回车事件
$(document).keydown(function (event) {
    if (event.keyCode == 13) {
        if (location.href.indexOf('/login') > -1) {
            $('.login_btn').click();
        } else if (location.href.indexOf('/register') > -1) {
            $('.register_btn').click();
        } else if (location.href.indexOf('/passwordless-login') > -1) {
            $('.passless_login_btn').click();
        } else if (location.href.indexOf('/connect-account') > -1) {
            $('.bind .bind_btn').click();
        } else if (location.href.indexOf('/create-password') > -1) {
            $('.create_password .create_password_btn').click();
        } else if (location.href.indexOf('/reset-password') > -1) {
            $('.reset .reset_btn').click();
        } else { }
    }
});
// tips
$('body').click(function () {
    $('.member .code_box>p>span>span>i').hide();
    $('.info_form').hide();
});
$('.code_box').on('click', '.tips', function (e) {
    e.stopPropagation();
    $(this).find('i').show()
});
//暂时去掉
// $('.code_box').on('click','.on_feedback',function(){
//     $('.feedback').show();
// });
$('.code_box').on('click', '.close', function (e) {
    e.stopPropagation();
    $('.member .code_box>p>span>span>i').hide();
});
if ($('.feedback').length == 0) {
    // feedback
    $('body').append(`<form action="javascript:;" class="feedback clearfloat" method="post" id="feedback">
    <i class="feedback_close"></i>
    <div class="feedback_container clearfloat">
      <p class="title">
        ${i18n[lang].feedback_title}
      </p>
      <p>${i18n[lang].email}</p>
      <div>
        <input name="email" class="form_email" id="mail" placeholder="${i18n[lang].feedback_email}" />
        <p></p>
      </div>
      <p>${i18n[lang].Contents}</p>
      <div>
        <textarea name="content" id="form_contents" cols="30" rows="10" form="feedback" placeholder="${i18n[lang].feedback_content}"></textarea>
        <p></p>
      </div>
      <input type="hidden" name="f_source" value="3" /><input type="hidden" name="product_id" value="70009" />
      <input type="submit" value="${i18n[lang].feedback_submit}" id="form_submit" name="submit" />
    </div>
    </form>
    <div class="info_form" style="display: none">
    ${i18n[lang].feedback_thank_you}
    </div>
    `);
    //feedback提交事件
    $('#feedback #mail').focus(function () {
        $(this).next().html('');
    });
    $('#feedback #mail').blur(function () {
        if ($(this).val() == "") {
            $(this).next().html(i18n[lang].email_empty);
        }
        if (!reg_email.test($(this).val())) {
            $(this).next().html(i18n[lang].email_not_valid_2);
        }
    });
    $('#feedback #form_contents').focus(function () {
        $(this).next().html('');
    });
    $('#feedback #form_contents').blur(function () {
        if ($('#feedback #form_contents').val() == '') {
            $('#feedback #form_contents').next().html(i18n[lang].form_contents);
        }
    });
    $('#feedback').on('click', '#form_submit', function (e) {
        e.stopPropagation();
        if (!isnetwork()) { return false; };
        var mail = $.trim($('#feedback #mail').val());
        if ($('#feedback #mail').val() == '') {
            $('#feedback #mail').next().html(i18n[lang].email_empty);
            return false;
        }
        if (!reg_email.test(mail)) {
            $('#feedback #mail').next().html(i18n[lang].email_not_valid_2);
            return false;
        }
        if ($('#feedback #form_contents').val() == '') {
            $('#feedback #form_contents').next().html(i18n[lang].form_contents);
            return false;
        }
        var data = { f_source: '3', product_id: '70015', email: '', content: '' };
        data['email'] = $('#feedback #mail').val();
        data['content'] = $('#feedback #form_contents').val();
        $('#feedback #mail').val('');
        $('#feedback #form_contents').val('');
        $('.info_form').fadeIn().delay(2000).fadeOut();
        $.ajax({
            url: 'https://support.heyreal.ai/api/feedback/v1/index.php',
            type: 'post',
            data: data,
        });
        $('#feedback').css({ display: 'none' });
    });
    $('.feedback_close').click(function (e) {
        e.stopPropagation();
        $('.feedback').hide();
    })
}
// 登录成功点击完成跳转
$('.member').on('click', '.done', function () {
    if (sessionStorage.getItem('operation') == 'close') {
        closeTab()
    } else {
        location.href = localStorage.getItem('source');
    }
});
if ($('.success .done.time').length > 0) {
    var timer_num = 6;
    timeClock = setInterval(function () {
        timer_num--;
        $('.success .done.time').html(i18n[lang].Done + '(' + timer_num + 's)');
        if (timer_num == 0) {
            if (sessionStorage.getItem('operation') == 'close') {
                closeTab()
            } else {
                location.href = localStorage.getItem('source');
            }
            clearInterval(timeClock)
            $('.success .done').html(i18n[lang].Done);
        }
    }, 1000);
}
function btn_success(element) {
    var timer_num = 3;
    element.addClass('done');
    element.html(i18n[lang].Done + '(' + timer_num + 's)');
    timeClock = setInterval(function () {
        timer_num--;
        element.html(i18n[lang].Done + '(' + timer_num + 's)');
        if (timer_num == 0) {
            if (sessionStorage.getItem('operation') == 'close') {
                closeTab()
            } else {
                location.href = localStorage.getItem('source');
            }
        }
    }, 1000);
};
// 关闭当前窗口
function closeTab() {
    var browserName = navigator.appName;
    if (browserName == "Netscape") {
        window.location.href = "about:blank";
        window.opener = 'Account'
        window.close();
    }
    else {
        if (browserName == "Microsoft Internet Explorer") {
            window.opener = "Account";
            window.opener = null;
            window.open('', '_top');
            window.close();
        }
    }
    window.opener = null;
    window.open('', '_self');
    window.close();
}
//成功自动给登录处理
function autho_success(element, callback) {
    if (!isnetwork()) { return false; };
    let that = element;
    let email = that.siblings().find('.email').val();
    let password = that.siblings().find('.password').val();
    if (that.attr('class').indexOf('done') > -1) { return false; };
    if (!email) {
        //判断邮箱是否为空
        that.siblings().find('.email').addClass('active');
        that.siblings().find('.email').next().html(i18n[lang].email_empty);
        return false;
    } else if (!reg_email.test(email)) {
        //正则判断格式是否正确
        that.siblings().find('.email').addClass('active');
        that.siblings().find('.email').next().html(i18n[lang].email_not_valid);
        return false;
    } else if (!password) {
        //判断秘密是否为空
        that.siblings().find('.password').next().html(i18n[lang].password_empty);
        return false;
    } else if (!reg_password.test(password)) {
        //密码格式是否正确
        that.siblings().find('.password').next().html(i18n[lang].password_not_valid);
        return false;
    } else {
        that.find('img').css('opacity', 1);
        //发送请求
        $.post(
            post_url + "account/email/login",
            {
                e_id: murmur,
                email: email,
                password: password
            },
            function (data) {
                that.find('img').css('opacity', 0);
                error_fn(data.code, that);
                switch (data.code) {
                    case 0:
                        setCookie('user', JSON.stringify({ 'e_id': murmur, 't_id': data.data.t_id, 'token': data.data.token }), 90);
                        if (callback) {
                            callback();
                            return false;
                        }
                        if (getQueryVariable('type')) {
                            location.href = `${lang_path}/`;
                        } else {
                            if (sessionStorage.getItem('operation') == 'close') {
                                location.href = `${lang_path}/successful-login`
                            } else {
                                location.href = localStorage.getItem('source');
                            }
                        }
                        break;
                    case 20301:
                        that.parents('.login').find('.email').next().html(i18n[lang].error_20301);
                        break;
                    case 20302:
                        that.parents('.login').find('.password').next().html(i18n[lang].error_20302);
                        break;
                    case 20303:
                        that.parents('.login').find('.email').next().html(i18n[lang].error_20303);
                        break;
                    case 20304:
                        that.find('p').html(i18n[lang].error_20304);
                        break;
                    case 20305:
                        that.parents('.login').find('.email').next().html(i18n[lang].error_20305);
                        break;
                    case 20306:
                        that.parents('.login').find('.password').next().html(i18n[lang].error_20306);
                        break;
                    case 20307:
                        that.parents('.login').find('.password').next().html(i18n[lang].password_not_valid);
                        break;
                    case 20308:
                        that.find('p').html(i18n[lang].error_20308);
                        break;
                }
            }
        ).error(function (xhr) {
            that.find('img').css('opacity', 0);
            overtime(20399);
        });
    };
};
// $(document).click(function(e){
//     e.stopPropagation();
//     $('body>.success').fadeOut();
//     $('body>.error').fadeOut();
// });
$('.delet_accout input').focus(function () {
    input_placeholder = $(this).attr('placeholder');
    $(this).attr('placeholder', '');
    $(this).parent().find('p').html('');
})
// code
$('.delet_accout input.code').blur(function () {
    if ($(this).attr('readonly')) {
        return false;
    } else {
        if (!$(this).val()) {
            $(this).next().next().html(i18n[lang].code_empty);
        } else if (!reg_code.test($(this).val())) {
            $(this).next().next().html(i18n[lang].code_not_valid);
        } else {
            $(this).next().next().html('');
            $('.delete_now').addClass('active')
        }
    }
});
$('.delet_accout input.code').focus(function () {
    $(this).attr('readonly', false)
});
$('.delet_accout input.code').on('input', function () {
    if (!$(this).val()) {
        $(this).next().next().html(i18n[lang].code_empty);
    } else if (!reg_code.test($(this).val())) {
        $(this).next().next().html(i18n[lang].code_not_valid);
    } else {
        $(this).next().next().html('');
        $('.delete_now').addClass('active')
    }
});
$('.delet_accout input.code').focus(function () {
    if ($(this).attr('readonly')) {
        $(this).attr('placeholder', input_placeholder);
        $(this).next().next().html(i18n[lang].get_first_code);
    }
});
//warning
var delete_now = 1;
$('.delet_accout .delete_now').click(function (e) {
    if ($(this).attr('class').indexOf('active') > -1) {
        if (personal.session.type * 1 == 1 || personal.session.type * 1 == 2) {
            // if(delete_now){
            //     $(this).addClass('active').html(i18n[lang].delete_no).css("marginTop",'0px');
            //     $('.delet_accout .warning,.delet_accout .input_box').addClass('active');
            //     delete_now=0;
            // }else{
            e.stopPropagation();
            let that = $(this);
            if (!isnetwork()) { return false; };
            if ($('.delet_accout .code').val() == '') {
                $('.delet_accout .getcode').next().html(i18n[lang].code_empty)
                return false;
            }
            if ($('.delet_accout .code').val() && reg_code.test($('.delet_accout .code').val())) {
                that.html('<img src="/images/account/loading.svg" alt="Loading">');
                if (user_plan != 'Free') {
                    $('.delet_failed').addClass('active').siblings().removeClass('active')
                } else {
                    $.ajax({
                        url: post_url + 'account/email/delete',
                        type: 'POST',
                        headers: {
                            "Access-Token": JSON.parse(cookie.getcookie('user')).token,
                        },
                        data: {
                            e_id: eId,
                            t_id: JSON.parse(cookie.getcookie('user')).t_id,
                            authcode: $('.delet_accout .code').val(),
                        },
                        success: function (data) {
                            that.html(i18n[lang].delete_no);
                            error_fn(data.code)

                            switch (data.code) {
                                case 0:
                                    _success(i18n[lang].error_21500);
                                    try { cookie.deletecookie('user_google'); } catch (e) { };
                                    try { cookie.deletecookie('google_id_token'); } catch (e) { };
                                    try { cookie.deletecookie('userInfoData'); } catch (e) { };
                                    try { cookie.deletecookie('user'); } catch (e) { };
                                    setTimeout(function () {
                                        location.href = `${lang_path}/account/login/`;
                                    }, 3000)
                                    break;
                                case 21501:
                                    _error(i18n[lang].error_21501);
                                    break;
                                case 21502:
                                    _error(i18n[lang].error_21502);
                                    setTimeout(function () {
                                        location.href = `${lang_path}/account/login/`;
                                    }, 3000)
                                    break;
                                case 21503:
                                    _error(i18n[lang].error_21503);
                                    break;
                                case 21504:
                                    _error(i18n[lang].code_not_valid);
                                    break;
                                case 21505:
                                    _error(i18n[lang].error_21505);
                                    break;
                            }
                        },
                        error: function (xhr, status, error) {
                            overtime(21599);
                        }
                    });
                }
            } else {
                $('.delet_accout .getcode').next().html(i18n[lang].error_20207)
            }
            // }
        } else if (personal.session.type * 1 == 3) {
            // if(delete_now){
            //     $(this).addClass('active').html(i18n[lang].delete_no);
            //     delete_now=0;
            // }else{
            $.ajaxSetup({
                headers: {
                    'Access-Token': JSON.parse(cookie.getcookie('user')).token
                }
            });
            e.stopPropagation();
            let that = $(this);
            if (!isnetwork()) { return false; };
            that.html('<img src="/images/account/loading.svg" alt="Loading">');
            $.post(
                post_url + 'account/google/delete',
                {
                    e_id: eId,
                    id_token: JSON.parse(cookie.getcookie('google_id_token')).google_id_token
                },
                function (data) {
                    that.html(i18n[lang].delete_no);
                    error_fn(data.code)
                    switch (data.code) {
                        case 200:
                            _success(i18n[lang].error_21500);
                            try { cookie.deletecookie('user_google'); } catch (e) { };
                            try { cookie.deletecookie('google_id_token'); } catch (e) { };
                            try { cookie.deletecookie('userInfoData'); } catch (e) { };
                            try { cookie.deletecookie('user'); } catch (e) { };
                            setTimeout(function () {
                                location.href = `${lang_path}/account/login/`;
                            }, 3000)
                            break;
                        case 22101:
                            _error(i18n[lang].error_22101);
                            break;
                        case 22102:
                            _error(i18n[lang].error_22102);
                            //这个我前面做了判断有email的时候不会进入到这层，改下文字
                            break;
                        case 22103:
                            _error(i18n[lang].error_22103);
                            break;
                        case 22104:
                            _error(i18n[lang].error_22104);
                            //刷新Profile
                            break;
                        case 22105:
                            _error(i18n[lang].error_22105);
                            break;
                        case 22106:
                            _error(i18n[lang].error_22106);
                            break;
                        case 22107:
                            _error(i18n[lang].error_22107);
                            break;
                        case 22108:
                            _error(i18n[lang].error_22108);
                            break;
                    }
                }
            ).error(function (xhr) {
                overtime(22199);
            })
            // }
        }
    }
});
// 删除邮箱账号获取验证码
$('.delet_accout .getcode').click(function (e) {
    e.stopPropagation();
    if (!isnetwork()) { return false; };
    var that = $(this);
    if (that.attr('class').indexOf('nobind') > 0) {
        return false;
    }
    that.addClass('nobind');
    that.html('<img src="/images/account/loading.svg" alt="Loading">');
    // 获取邮箱
    $.ajax({
        url: post_url + "account/profile",
        type: 'POST',
        headers: {
            "Access-Token": JSON.parse(cookie.getcookie('user')).token,
        },
        data: {
            e_id: eId,
            t_id: JSON.parse(cookie.getcookie('user')).t_id,
        },
        success: function (res) {
            that.html('Get');
            error_fn(res.code)
            let email = res.email;
            that.next().html('');
            that.html('<img src="/images/account/loading.svg" alt="Loading">');
            $.ajax({
                url: post_url + "account/authcode/email/delete",
                type: 'POST',
                headers: {
                    "Access-Token": JSON.parse(cookie.getcookie('user')).token,
                },
                data: {
                    e_id: eId,
                    t_id: JSON.parse(cookie.getcookie('user')).t_id,
                    token: JSON.parse(cookie.getcookie('user')).token,
                    email: email,
                    language: lang.toLowerCase()
                },
                success: function (res) {
                    that.prev().removeAttr('readonly');
                    that.prev().css('cursor', 'auto');
                    sendCode(that, true);
                    error_fn(res.code, that);
                    switch (res.code) {
                        case 0:
                            that.parents('.delet_accout').find('.code').next().next().html(no_code_text);
                            that.parents('.delet_accout').find('.password_box').show();
                            break;
                        case 21401:
                            //不提示走三方验证删除

                            break;
                        case 21402:
                            that.parents('.delet_accout').find('.code').next().next().html(i18n[lang].error_21402);
                            break;
                        case 21403:
                            that.parents('.delet_accout').find('.code').next().next().html(i18n[lang].error_21403);
                            break;
                    }
                    if (res.code != 0) {
                        sendCode(that, false);
                    }
                },
                error: function (xhr, status, error) {
                    // 错误回调
                }
            });
        },
        error: function (xhr, status, error) {
            that.prev().removeAttr('readonly');
            that.prev().css('cursor', 'pointer');
            sendCode(that, false);
            overtime(21499);
        }
    });

});
// tips
$('body').click(function () {
    $('.delet_accout .code_box>p>span>span>i').hide();
    $('.info_form').hide();
});
$('.code_box').on('click', '.close', function (e) {
    e.stopPropagation();
    $('.delet_accout .code_box>p>span>span>i').hide();
});


//取消订阅
$('.cancel_renewal,.subscribeMask .close,.subscribeMask .cancel').click(function () {
    $('.profile_mask').removeClass('active');
    $('.subscribeMask').toggleClass('active');
})

$('.button.confirm').click(function () {
    getAjax(_url.useePayCancelSub,).then(res => {
        if (res.code == 200) {
            $('.cancel_renewal').hide();
            showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_7, '/images/toast/icon_su.svg');

        } else {
            showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_8, '/images/toast/icon_dialogue.svg');
        }
        $('.profile_mask').removeClass('active');
        $('.subscribeMask').toggleClass('active');
    })
})